import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  Grid,
  TextField,
  Paper,
  Typography,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  withStyles,
  Button,
  Dialog,
  Card,
  CardActionArea,
  CardContent,
  CardActions,
  ImageList,
  ImageListItem,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  Menu,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
  IconButton,
  InputAdornment,
  NativeSelect,
  LinearProgress,
  CircularProgress,
  ListSubheader,
} from "@material-ui/core";
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import AttachFileRoundedIcon from '@material-ui/icons/AttachFileRounded';
import { useHistory, Link } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Pagination from "@material-ui/lab/Pagination";
import Skeleton from "@material-ui/lab/Skeleton";
import InboxRoundedIcon from "@material-ui/icons/InboxRounded";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import GroupRoundedIcon from "@material-ui/icons/GroupRounded";
import SendRoundedIcon from "@material-ui/icons/SendRounded";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import DescriptionRoundedIcon from "@material-ui/icons/DescriptionRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import SwapHorizRoundedIcon from "@material-ui/icons/SwapHorizRounded";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import InsertDriveFileRoundedIcon from "@material-ui/icons/InsertDriveFileRounded";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HttpService from "../../services/httpService";
import { setSnackInfo } from "../../redux/actions/appAction";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import { CSVLink } from "react-csv";
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import DeleteOutlineRoundedIcon from '@material-ui/icons/DeleteOutlineRounded';
import ReplayIcon from '@material-ui/icons/Replay';
import RepeatIcon from '@material-ui/icons/Repeat';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import PeopleAltRoundedIcon from '@material-ui/icons/PeopleAltRounded';
import ScheduleRoundedIcon from '@material-ui/icons/ScheduleRounded';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import CreateTaskTicket from "./CreateTaskTicket";
import { ROLENAME } from '../../utils/index';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// ---- Design tokens taken from the reference screenshot ----
const NAVY = "#1C375D";
const ORANGE = "#F47E46";
// Darker than ORANGE for small text. #F47E46 measures 2.40 against its own
// #FEF1EA tint and #C25526 only 4.11 - both under AA. This clears it at 4.87.
const ORANGE_DARK_TM = "#B14B1F";
const PAGE_BG = "#F4F7FB";
const CARD_BORDER = "#E5E9F2";
const MUTED = "#7B8AA5";

// One definition of the view list, so the closed field, the menu and the
// counts cannot drift apart. `group` rows are headings, not options.
const TICKET_VIEWS = [
  { value: "View All Tickets", label: "All tickets", Icon: InboxRoundedIcon },
  { group: "Customer" },
  { value: "Customer Tickets Assigned To Me", label: "Assigned to me", Icon: PersonRoundedIcon },
  { value: "Customer Tickets Assigned To My Team", label: "Assigned to my team", Icon: GroupRoundedIcon, teamOnly: true },
  { group: "Internal" },
  { value: "Tickets Assigned To Me", label: "Assigned to me", Icon: PersonRoundedIcon },
  { value: "Tickets Assigned To My Team", label: "Assigned to my team", Icon: GroupRoundedIcon, teamOnly: true },
  { value: "Tickets Assigned By Me", label: "Raised by me", Icon: SendRoundedIcon },
  { group: "Tech" },
  { value: "Tech Related Query", label: "ERP Tech Support Tickets", Icon: CodeRoundedIcon },
];

// The STORED category value, not the label shown in the picker - renaming the
// label does not move this, and Mongo is queried on it.
const TECH_CATEGORY_VALUE = "Tech Related Query";
const TECH_DEPARTMENT_NAME = "Tech";

const BrandLinearProgress = withStyles(() => ({
  root: { height: 3, borderRadius: 999, backgroundColor: "rgba(244,126,70,0.16)" },
  bar: { borderRadius: 999, backgroundColor: ORANGE },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
  page: {
    backgroundColor: PAGE_BG,
    minHeight: "100%",
    padding: "20px 24px 40px 24px",
    boxSizing: "border-box",
  },
  pageTitle: {
    color: NAVY,
    fontWeight: 700,
    fontSize: 26,
    lineHeight: 1.2,
  },
  pageSubTitle: {
    color: MUTED,
    fontSize: 13,
    marginTop: 4,
  },
  card: {
    background: "#FFFFFF",
    border: `1px solid ${CARD_BORDER}`,
    borderRadius: 14,
    boxShadow: "0 1px 3px rgba(28,55,93,0.06)",
    padding: "16px 20px",
    marginBottom: 18,
  },
  fieldLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: NAVY,
    marginBottom: 6,
    display: "block",
  },
  createButton: {
    backgroundColor: ORANGE,
    color: "#FFFFFF",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 10,
    padding: "10px 20px",
    boxShadow: "none",
    '&:hover': {
      backgroundColor: "#E0663D",
      boxShadow: "none",
    },
  },
  submitButton: {
    backgroundColor: NAVY,
    color: "#FFFFFF",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "8px 24px",
    boxShadow: "none",
    '&:hover': { backgroundColor: "#2A4B6C", boxShadow: "none" },
    '&.Mui-disabled': { backgroundColor: "#C9D3E4", color: "#FFFFFF" },
  },
  clearButton: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "8px 20px",
    color: NAVY,
    borderColor: "#C9D3E4",
  },
  csvButton: {
    backgroundColor: "#148F4E",
    color: "#FFFFFF",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "9px 18px",
    whiteSpace: "nowrap",
    boxShadow: "none",
    '&:hover': { backgroundColor: "#0F7540", boxShadow: "none" },
  },

  // ---- Status summary ----
  summaryTitle: { color: NAVY, fontWeight: 700, fontSize: 20, lineHeight: 1.2 },
  summarySubTitle: { color: MUTED, fontSize: 13 },
  statCard: {
    borderRadius: 12,
    padding: "14px 16px",
    border: "1px solid",
    height: "100%",
    boxSizing: "border-box",
  },
  statLabel: { fontSize: 14, fontWeight: 600, color: NAVY },
  statValue: { fontSize: 30, fontWeight: 700, color: NAVY, lineHeight: 1.1, marginTop: 4 },
  statPercent: { fontSize: 12, color: MUTED, marginTop: 4 },
  statIconBox: {
    width: 34, height: 34, borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#FFFFFF", marginRight: 10,
  },
  legendRow: { display: "flex", alignItems: "center", marginBottom: 12 },
  legendDot: { width: 12, height: 12, borderRadius: "50%", marginRight: 10, flexShrink: 0 },
  legendLabel: { fontSize: 14, fontWeight: 600, color: NAVY, minWidth: 90 },
  legendValue: { fontSize: 14, color: "#5A6B87" },

  // ---- Table ----
  tableCard: {
    background: "#FFFFFF",
    border: `1px solid ${CARD_BORDER}`,
    borderRadius: 14,
    boxShadow: "0 1px 3px rgba(28,55,93,0.06)",
    overflow: "hidden",
  },
  // `stickyHeader` on the Table does nothing without a scroll container that
  // has a bounded height - this only had overflowX, so the header scrolled
  // away with the rows and a 100-row page lost its column names immediately.
  //
  // 60px of chrome below the table (pagination) plus the cards above it; the
  // floor keeps it usable on a short window.
  tableScroll: {
    overflow: "auto",
    maxHeight: "calc(100vh - 420px)",
    minHeight: 260,
  },
  // ---- view ticket dialog ----
  viewPaper: { borderRadius: 16, overflow: "hidden" },
  viewHead: {
    display: "flex", alignItems: "center", gap: 13,
    padding: "18px 22px", background: NAVY, color: "#FFFFFF",
  },
  viewTicketNo: {
    fontSize: 11, fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase",
    color: "#F0997B",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
  },
  viewTitle: { fontSize: 17, fontWeight: 700, lineHeight: 1.3, marginTop: 3 },
  viewClose: { background: "rgba(0,0,0,0.22)", color: "#FFFFFF", flexShrink: 0 },
  viewMeta: {
    display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap",
    padding: "12px 22px", background: "#F6F8FC", borderBottom: `1px solid ${CARD_BORDER}`,
  },
  viewMetaItem: { display: "inline-flex" },
  viewChip: {
    display: "inline-flex", alignItems: "center", gap: 5,
    fontSize: 11.5, fontWeight: 600, color: "#44546F",
    background: "#FFFFFF", border: `1px solid ${CARD_BORDER}`,
    borderRadius: 999, padding: "3px 11px", whiteSpace: "nowrap",
  },
  viewBody: {
    padding: "20px 22px 24px", display: "flex", flexDirection: "column", gap: 22,
    maxHeight: "calc(100vh - 290px)", overflow: "auto",
  },
  viewSectionLabel: {
    display: "flex", alignItems: "center", gap: 8, marginBottom: 10,
    fontSize: 11, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase",
    color: "#5D6B82",
  },
  viewCount: {
    fontSize: 10.5, fontWeight: 800, color: ORANGE_DARK_TM,
    background: "#FEF1EA", borderRadius: 999, padding: "1px 8px",
  },
  viewDescription: {
    fontSize: 13.5, color: NAVY, lineHeight: 1.65,
    background: "#F6F8FC", border: `1px solid ${CARD_BORDER}`,
    borderRadius: 12, padding: "14px 16px", overflowX: "auto",
    "& p": { margin: "0 0 8px" },
  },
  viewImages: { margin: 0 },
  fileList: { display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 },
  fileChip: {
    display: "inline-flex", alignItems: "center", gap: 7,
    fontSize: 12.5, fontWeight: 600, color: NAVY, textDecoration: "none",
    background: "#FFFFFF", border: `1px solid ${CARD_BORDER}`,
    borderRadius: 10, padding: "8px 12px",
    "&:hover": { borderColor: "#C9D3E4", background: "#F6F8FC" },
  },
  downloadBtn: {
    marginLeft: "auto", textTransform: "none", fontSize: 12, fontWeight: 700,
    color: ORANGE_DARK_TM, borderRadius: 999, padding: "2px 12px",
    border: `1px solid #F3C9B2`,
  },

  // ---- proof attachments on resolve / close ----
  proofHead: { display: "flex", alignItems: "center", gap: 10, marginBottom: 8 },
  proofLabel: {
    fontSize: 12, fontWeight: 700, color: "#5D6B82",
    textTransform: "uppercase", letterSpacing: 0.4,
    display: "inline-flex", alignItems: "center",
  },
  attachBtn: {
    marginLeft: "auto", textTransform: "none", fontSize: 12, fontWeight: 700,
    color: ORANGE_DARK_TM, borderRadius: 999, padding: "2px 12px",
    border: `1px solid #F3C9B2`,
    "&.Mui-disabled": { color: "#A89F98", borderColor: "#E6E1DD" },
  },
  proofHint: { fontSize: 12, color: "#7A8699", lineHeight: 1.5 },
  proofList: { display: "flex", flexDirection: "column", gap: 6 },
  proofItem: {
    display: "flex", alignItems: "center", gap: 8,
    border: "1px solid #E2E8F2", borderRadius: 10,
    padding: "5px 6px 5px 10px", background: "#F8FAFD",
  },
  proofName: {
    flexGrow: 1, minWidth: 0, fontSize: 12.5, fontWeight: 600, color: NAVY,
    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
    textDecoration: "none", "&:hover": { textDecoration: "underline" },
  },
  // Attachments shown under a remark in the timeline.
  logFiles: { display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 },
  logFile: {
    display: "inline-flex", alignItems: "center", gap: 6, maxWidth: 240,
    border: "1px solid #E2E8F2", borderRadius: 999, padding: "3px 10px",
    background: "#FFFFFF", fontSize: 12, fontWeight: 600, color: NAVY,
    textDecoration: "none",
    "&:hover": { background: "#F1F5FB", borderColor: "#C9D7EC" },
  },
  logFileName: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  timeline: { display: "flex", flexDirection: "column", gap: 12 },
  timelineItem: {
    display: "flex", gap: 11,
    background: "#FFFFFF", border: `1px solid ${CARD_BORDER}`,
    borderRadius: 12, padding: "12px 14px",
  },
  timelineAvatar: {
    width: 30, height: 30, borderRadius: "50%", flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 11, fontWeight: 800, background: "#E4ECFA", color: NAVY,
  },
  timelineHead: { display: "flex", alignItems: "baseline", gap: 9, flexWrap: "wrap" },
  timelineWho: { fontSize: 13, fontWeight: 700, color: NAVY },
  timelineWhen: { fontSize: 11.5, color: "#5D6B82" },
  timelineBody: {
    fontSize: 13, color: "#44546F", lineHeight: 1.55, marginTop: 3,
    "& p": { margin: 0 },
  },
  viewEmpty: {
    fontSize: 13, color: "#5D6B82", textAlign: "center",
    padding: "22px 16px", background: "#F6F8FC",
    border: `1px dashed ${CARD_BORDER}`, borderRadius: 12,
  },

  reopenBtn: {
    minHeight: 40, padding: "0 22px", borderRadius: 10,
    background: "#8A6100", color: "#FFFFFF",
    fontSize: 13.5, fontWeight: 700, textTransform: "none",
    "&:hover": { background: "#6E4D00" },
    "&.Mui-disabled": { background: "#EFE9E5", color: "#A89F98" },
  },

  // ---- row actions ----
  actionTrigger: {
    minHeight: 30, padding: "0 10px 0 13px", borderRadius: 999,
    border: "1px solid #D7DEEA", background: "#FFFFFF", color: NAVY,
    fontSize: 12.5, fontWeight: 700, textTransform: "none", whiteSpace: "nowrap",
    "&:hover": { background: "#F6F8FC", borderColor: "#C9D3E4" },
  },
  actionMenuPaper: { borderRadius: 12, minWidth: 262, marginTop: 4, paddingTop: 4, paddingBottom: 4 },
  actionItem: {
    display: "flex", alignItems: "center", gap: 12,
    paddingTop: 8, paddingBottom: 8,
  },
  actionItemDanger: {
    display: "flex", alignItems: "center", gap: 12,
    paddingTop: 8, paddingBottom: 8,
    "&:hover": { background: "#FDF2F0" },
  },
  actionIcon: {
    width: 30, height: 30, borderRadius: 9, flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  actionText: { display: "flex", flexDirection: "column", minWidth: 0, lineHeight: 1.3 },
  actionLabel: { fontSize: 13.5, fontWeight: 600, color: NAVY },
  // #5D6B82, not MUTED: that one measures 4.34 on white, under AA at 11px.
  actionHint: { fontSize: 11, color: "#5D6B82", marginTop: 1 },
  actionDivider: { margin: "5px 0" },

  // ---- edit dialog ----
  editBody: {
    padding: "20px 22px 6px", display: "flex", flexDirection: "column", gap: 18,
    maxHeight: "calc(100vh - 290px)", overflow: "auto",
  },
  editLabel: { fontSize: 13, fontWeight: 600, color: NAVY, marginBottom: 6, display: "block" },

  // ---- reassign picker ----
  raStack: { display: "flex", flexDirection: "column", gap: 16 },
  raStep: { display: "flex", gap: 12, alignItems: "flex-start" },
  raBadge: {
    width: 22, height: 22, borderRadius: "50%", flexShrink: 0, marginTop: 26,
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 11, fontWeight: 800, color: "#FFFFFF", background: ORANGE,
  },
  raLabel: { fontSize: 13, fontWeight: 600, color: NAVY, marginBottom: 6, display: "block" },
  raHint: { fontSize: 11.5, color: "#5D6B82", marginTop: 6, display: "block" },
  raUserRow: { display: "flex", alignItems: "center", gap: 11, minWidth: 0, padding: "2px 0" },
  raAvatar: {
    width: 32, height: 32, borderRadius: "50%", flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 11, fontWeight: 800, background: "#E4ECFA", color: NAVY,
  },
  raUserName: { fontSize: 13.5, fontWeight: 700, color: NAVY, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  raUserMeta: { fontSize: 11.5, color: "#5D6B82", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  raUserRole: { fontSize: 11, fontWeight: 600, color: "#2F7BEF", marginTop: 1 },
  raBlocker: {
    marginRight: "auto", fontSize: 12, fontWeight: 700, color: "#9C4A16",
    display: "inline-flex", alignItems: "center",
  },

  // ---- confirm dialog ----
  confirmPaper: { borderRadius: 16, overflow: "hidden" },
  confirmHead: {
    display: "flex", alignItems: "center", gap: 13,
    padding: "18px 22px", background: NAVY, color: "#FFFFFF",
    flexShrink: 0,
  },
  confirmHeadIcon: {
    width: 38, height: 38, borderRadius: 11, flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    // Darkened, not frosted: a translucent white panel on navy washes out.
    background: "rgba(0,0,0,0.22)",
  },
  confirmTitle: { fontSize: 17, fontWeight: 700, lineHeight: 1.25 },
  confirmSub: { fontSize: 12.5, color: "rgba(255,255,255,0.82)", marginTop: 3, lineHeight: 1.45 },
  confirmBar: {
    height: 3,
    backgroundColor: "rgba(244,126,70,0.18)",
    "& .MuiLinearProgress-bar": { backgroundColor: ORANGE },
  },
  // Scrolls. confirmPaper sets `overflow: hidden`, which beats MUI's own
  // `overflowY: auto` on the dialog paper, so with a remark plus ten attached
  // files this body would otherwise be clipped with no scrollbar - the paper
  // is a flex column capped at calc(100% - 64px) and shrinks its children to
  // fit. Giving the scroll to the body keeps the heading and the buttons put.
  confirmBody: {
    padding: "20px 22px 6px", display: "flex", flexDirection: "column", gap: 16,
    flex: "1 1 auto", minHeight: 0, overflowY: "auto",
  },
  ticketCard: {
    border: `1px solid ${CARD_BORDER}`, borderRadius: 12, background: "#F6F8FC",
    padding: "12px 14px", display: "flex", flexDirection: "column", gap: 9,
  },
  ticketRow: { display: "flex", alignItems: "center", gap: 12 },
  ticketLabel: {
    fontSize: 10.5, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase",
    color: "#5D6B82", width: 62, flexShrink: 0,
  },
  ticketIdText: {
    fontSize: 13, fontWeight: 800, color: NAVY,
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
  },
  ticketTitleText: { fontSize: 13.5, fontWeight: 600, color: NAVY, lineHeight: 1.45, minWidth: 0 },
  confirmActions: {
    display: "flex", justifyContent: "flex-end", gap: 10,
    padding: "14px 22px 18px",
    flexShrink: 0, background: "#FFFFFF",
  },
  ghostBtn: {
    minHeight: 40, padding: "0 20px", borderRadius: 10,
    border: "1px solid #C9D3E4", background: "#FFFFFF", color: NAVY,
    fontSize: 13.5, fontWeight: 600, textTransform: "none",
  },
  primaryBtn: {
    minHeight: 40, padding: "0 22px", borderRadius: 10,
    background: ORANGE, color: "#FFFFFF",
    fontSize: 13.5, fontWeight: 700, textTransform: "none",
    "&:hover": { background: "#E0663D" },
    "&.Mui-disabled": { background: "#EFE9E5", color: "#A89F98" },
  },
  // Closing ends the ticket for everyone, so it does not share the colour of
  // the ordinary action.
  dangerBtn: {
    minHeight: 40, padding: "0 22px", borderRadius: 10,
    background: "#B3261E", color: "#FFFFFF",
    fontSize: 13.5, fontWeight: 700, textTransform: "none",
    "&:hover": { background: "#8C1D18" },
    "&.Mui-disabled": { background: "#EFE9E5", color: "#A89F98" },
  },
  viewValue: { display: "flex", alignItems: "center", gap: 8, minWidth: 0 },
  viewValueText: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 600, color: NAVY },
  viewCount: {
    flexShrink: 0, fontSize: 11.5, fontWeight: 800, color: ORANGE,
    background: "#FEF1EA", borderRadius: 999, padding: "1px 8px",
  },
  viewMenuPaper: { maxHeight: 420, minWidth: 300, borderRadius: 12, marginTop: 4 },
  viewGroup: {
    fontSize: 10.5, fontWeight: 800, letterSpacing: "0.07em", textTransform: "uppercase",
    color: MUTED, lineHeight: "30px", background: "#F6F8FC",
  },
  viewItem: { display: "flex", alignItems: "center", gap: 12, paddingTop: 9, paddingBottom: 9 },
  viewItemMain: { display: "flex", alignItems: "center", gap: 10, minWidth: 0, flexGrow: 1 },
  viewItemIcon: { fontSize: 18, color: MUTED, flexShrink: 0 },
  viewItemText: { fontSize: 13.5, color: NAVY, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  viewItemCount: {
    flexShrink: 0, fontSize: 11.5, fontWeight: 800, color: ORANGE,
    background: "#FEF1EA", borderRadius: 999, padding: "1px 9px", minWidth: 26, textAlign: "center",
  },
  // A zero is still worth showing - "0" answers the question, an absent chip
  // leaves you wondering whether it failed to load.
  viewItemCountZero: {
    flexShrink: 0, fontSize: 11.5, fontWeight: 700, color: "#A7B2C4",
    background: "#F1F4F9", borderRadius: 999, padding: "1px 9px", minWidth: 26, textAlign: "center",
  },
  stickySecondRow: {
    "& .MuiTableCell-stickyHeader": { top: 46 },
  },
  "@media (max-height: 760px)": {
    tableScroll: { maxHeight: "calc(100vh - 320px)" },
  },
  emptyCell: { textAlign: "center", padding: "48px 16px", borderBottom: "none" },
  emptyTitle: { fontSize: 15, fontWeight: 700, color: NAVY, marginTop: 10 },
  emptyHint: { fontSize: 13, color: MUTED, marginTop: 4 },
  // Reserved height, so the cards below do not shift when the bar appears.
  progressSlot: { height: 3, marginBottom: 10 },
  activityRow: {
    display: "flex", alignItems: "center", gap: 8, minHeight: 22,
    margin: "0 0 10px 2px", fontSize: 12.5, fontWeight: 700, color: "#9A5B00",
  },
  table: { minWidth: 1100 },
  ticketId: { color: "#2F7BEF", fontWeight: 600 },
  personCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 8,
    whiteSpace: "nowrap",
  },
  avatar: {
    width: 28, height: 28, fontSize: 12, fontWeight: 600,
    backgroundColor: "#E4ECFA", color: NAVY,
  },
  pill: {
    display: "inline-block",
    padding: "4px 14px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  paginationBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    padding: "14px 18px",
    borderTop: `1px solid ${CARD_BORDER}`,
  },
  paginationText: { fontSize: 13, color: "#5A6B87" },

  // ---- Dialog styles (unchanged behaviour) ----
  root: { "& > *": { margin: theme.spacing(1) } },
  tablecontainer: { display: "flex", margin: "25px" },
  margin: { margin: theme.spacing(1) },
  activeButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
  },
  redButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
    margin: "10px"
  },
  normalButton: { margin: "10px" },
  cardDialog: { minWidth: "80%", cursor: 'default' },
  viewIssueDialog: { minWidth: "80%" },
  imageList: { width: 500 },
  reassign: { minWidth: "500px" },
  reassignAutocomplete: { margin: "20px" },
  editDialogue: { minWidth: "600px", cursor: 'default' },
  dateSize: { width: "50%" },
  quillEditor: {
    margin: "20px",
    maxWidth: "900px",
    width: "90%",
    "& .ql-container": { minHeight: "200px", maxHeight: "400px", overflow: "auto" }
  },
  donutChartContainer: {
    position: "relative",
    "&:hover .donutSegment": {
      opacity: 0.7,
    },
    "& .donutSegment": {
      transition: "opacity 0.2s ease, filter 0.2s ease",
      cursor: "pointer",
    },
    "& .donutSegment:hover": {
      filter: "brightness(1.2)",
      opacity: 1,
    },
  },
  tooltipContainer: {
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "white",
    padding: "8px 12px",
    borderRadius: 4,
    fontSize: 12,
    pointerEvents: "none",
    zIndex: 10,
    whiteSpace: "nowrap",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: NAVY,
    color: "#FFF2EB",
    fontWeight: 600,
    fontSize: 13,
    textAlign: "center",
    whiteSpace: "nowrap",
    padding: "14px 12px",
    borderBottom: "none",
  },
  body: {
    fontSize: 13,
    color: "#2D3C55",
    borderBottom: "1px solid #EEF1F6",
    padding: "12px",
  },
}))(TableCell);

// Rows are clickable (open View Ticket), so show a pointer cursor.
const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#FFFFFF",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#F7F9FD" },
  },
}))(TableRow);

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: "16px",
    backgroundColor: "rgba(97, 97, 97, 0.9)",
    color: "rgba(255, 255, 255, 1)",
  },
}))(Tooltip);

// Status values already used by the existing flow. Colors only - no status logic here.
const STATUS_META = [
  { key: "Pending", color: "#F5B93B", soft: "#FEF7E7", border: "#F6E3B4", pillBg: "#FEF3D7", pillText: "#8A6100" },
  { key: "Resolved", color: "#12A66E", soft: "#EDF9F3", border: "#BFE8D6", pillBg: "#DDF5E9", pillText: "#0C7043" },
  { key: "Closed", color: "#2F7BEF", soft: "#EDF4FE", border: "#C2D9FB", pillBg: "#E8ECF2", pillText: "#4A5C77" },
  { key: "Reopen", color: "#7C4DE0", soft: "#F4EFFD", border: "#DCCBF7", pillBg: "#EDE4FD", pillText: "#5B32B8" },
];

const SUMMARY_VIEWS = [
  "Tickets Assigned To Me",
  "Tickets Assigned To My Team",
  "Tickets Assigned By Me",
  "View All Tickets",
];

const SUMMARY_VIEW_LABELS = {
  "Tickets Assigned To Me": "Internal Tickets Assigned To Me",
  "Tickets Assigned To My Team": "Internal Tickets Assigned To My Team",
  "Tickets Assigned By Me": "Internal Tickets Assigned By Me",
  "View All Tickets": "All Tickets Combined (Internal + Customer + Tech)",
};

// Used only to pull the complete filtered set for the summary from the SAME
// existing /getFilteredTickets API (backend untouched).
const SUMMARY_FETCH_LIMIT = 10000;

const getInitials = (name) => {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  return (parts[0]?.[0] || "").concat(parts[1]?.[0] || "").toUpperCase() || "?";
};

// Enhanced SVG donut chart with hover effects
const TicketDonutChart = ({ segments, total }) => {
  const size = 210;
  const stroke = 40;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const [hoveredSegment, setHoveredSegment] = useState(null);
  let consumed = 0;

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img">
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          {total === 0 ? (
            <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E7EBF3" strokeWidth={stroke} />
          ) : (
            segments
              .filter((s) => s.value > 0)
              .map((s, idx) => {
                const length = (s.value / total) * circumference;
                const node = (
                  <circle
                    key={s.key}
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={s.color}
                    strokeWidth={stroke}
                    strokeDasharray={`${length} ${circumference - length}`}
                    strokeDashoffset={-consumed}
                    className="donutSegment"
                    style={{
                      opacity: hoveredSegment === null || hoveredSegment === s.key ? 1 : 0.4,
                      filter: hoveredSegment === s.key ? "brightness(1.2)" : "brightness(1)",
                      transition: "opacity 0.2s ease, filter 0.2s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => setHoveredSegment(s.key)}
                    onMouseLeave={() => setHoveredSegment(null)}
                  />
                );
                consumed += length;
                return node;
              })
          )}
        </g>
        <text x="50%" y="46%" textAnchor="middle" style={{ fontSize: 14, fill: MUTED }}>Total</text>
        <text x="50%" y="60%" textAnchor="middle" style={{ fontSize: 30, fontWeight: 700, fill: NAVY }}>{total}</text>
      </svg>
      {hoveredSegment && (
        <div
          style={{
            position: "absolute",
            bottom: -30,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white",
            padding: "6px 10px",
            borderRadius: 4,
            fontSize: 12,
            whiteSpace: "nowrap",
            zIndex: 10,
          }}
        >
          {hoveredSegment}
        </div>
      )}
    </div>
  );
};

const TaskManagementDashBoard = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { userDetails } = useSelector((state) => state.user);
  // Deep-link support (e.g. from /pending-task's Tickets Pending card): ?tab=<ribbon
  // tag value>&tagStatus=<Pending|Resolved|Closed|Reopen> pre-selects the ribbon tab
  // and Tag Status filter on first load.
  const initialParams = new URLSearchParams(props.location?.search || "");
  const [ribbonTagValue, setRibbonTagValue] = useState(initialParams.get("tab") || "Tickets Assigned To Me");
  const [fetchData, setFetchData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [viewIssueDialog, setViewIssueDialog] = useState(false);
  const [viewConfirmationDialog, setViewConfirmationDialog] = useState(false);
  const [viewDeleteConfirmationDialog, setViewDeleteConfirmationDialog] = useState(false);
  const [viewIssueData, setViewIssueData] = useState({});
  const [closeIssueData, setCloseIssueData] = useState({});
  const [confirming, setConfirming] = useState(false);
  const [resolveIssueData, setResolveIssueData] = useState({});
  const [categoryData, setCategoryData] = useState(["Pending", "Resolved", "Closed", "Reopen"]);
  const [selectedStatusData, setSelectedStatusData] = useState(initialParams.get("tagStatus") || '');
  const [searchTicketID, setSearchTicketID] = useState("");
  const [remarks, setRemarks] = useState("");
  // Proof files attached while resolving or closing. Uploaded as they are
  // picked, so what is held here is already S3 URLs - the submit call sends
  // the list, it does not wait on any upload.
  const [confirmFiles, setConfirmFiles] = useState([]);
  const [confirmUploading, setConfirmUploading] = useState(false);
  const [ribbonNumberInfo, setRibbonNumberInfo] = useState({});
  const [deleteIssueData, setDeleteIssueData] = useState({});
  const [viewReassignIssueDialog, setViewReassignIssueDialog] = useState(false);
  const [viewEditIssueDialog, setViewEditIssueDialog] = useState(false);
  const [reassignIssueData, setReassignIssueData] = useState({});
  const [editIssueData, setEditIssueData] = useState({});
  const [editTicketTitle, setEditTicketTitle] = useState('');
  const [editTicketDes, setEditTicketDes] = useState('');
  const [editDueDate, setEditDueDate] = useState('');
  const [editFollowUpDate, setEditFollowUpDate] = useState('');
  const [selectedAssignedTo, setSelectedAssignedTo] = useState(null);
  const [selectedSourceFilters, setSelectedSourceFilters] = useState([]);
  const [sourceFilterOptions] = useState(['All', 'Channel Partner', 'Facebook', 'Google', 'Partnership', 'Reference', 'Walk-In', 'Customer App', 'Website']);
  const [escalationCategories, setEscalationCategories] = useState([]);
  const [tatInternalTickets, setTatInternalTickets] = useState([]);
  const [emailTag, setEmailTag] = useState("");

  // ---- reassign picker --------------------------------------------------
  // The same department -> city -> centre -> person cascade the create form
  // uses, instead of typing an email and hoping. One fetch of the directory,
  // filtered in memory, so each step is instant.
  const [dirUsers, setDirUsers] = useState([]);
  const [dirDepartments, setDirDepartments] = useState([]);
  const [dirCentres, setDirCentres] = useState([]);
  const [dirLoading, setDirLoading] = useState(false);
  const [raDept, setRaDept] = useState(null);
  const [raCity, setRaCity] = useState(null);
  const [raCentre, setRaCentre] = useState(null);
  const [raUser, setRaUser] = useState(null);
  const [reassigning, setReassigning] = useState(false);
  const [createTicketFromNotes, setCreateTicketFromNotes] = useState(false);
  const [files, setFiles] = useState([""]);
  const [openCreateTicketDialog, setOpenCreateTicketDialog] = useState(false);
  const [isUserWithTeam, setIsUserWithTeam] = useState(true);
  const [AssignToData, setAssignToData] = useState([]);
  const csvButtonRef = useRef(null);
  const titleRef = useRef(null);
  const desciptionRef = useRef(null);
  const [viewReopenDialog, setViewReopenDialog] = useState(false);
  const [reopenIssueData, setReopenIssueData] = useState({});
  const [reopenRemarks, setReopenRemarks] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  // Complete filtered ticket set (all pages) used only for the summary cards/donut.
  const [summaryTickets, setSummaryTickets] = useState([]);
  // Bumped by the Clear button so the list refetches even when the filters were
  // already empty (state values don't change, so the effect wouldn't re-run).
  const [refreshKey, setRefreshKey] = useState(0);
  // Single "Action" menu state
  // One loader per thing that can be in flight, replacing the single global
  // props.setLoading. That one blanked the whole screen for everything from a
  // CSV export to a ticket-id search, so the table, its filters and the counts
  // all vanished together and nothing said which of them you were waiting on.
  const [ticketsLoading, setTicketsLoading] = useState(false);
  const [bootstrapping, setBootstrapping] = useState(true);
  const [actionBusy, setActionBusy] = useState(false);
  const [downloadingAll, setDownloadingAll] = useState(false);
  const [downloadDone, setDownloadDone] = useState(0);
  const [searching, setSearching] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [actionMenuRow, setActionMenuRow] = useState(null);
  const [actionMenuIndex, setActionMenuIndex] = useState(null);

  // Quill editor modules and formats
  const quillModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['clean']
    ],
  };

  const quillFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'indent',
    'align',
  ];

  // Helper function to format Experience Centers with max 2 codes + tooltip
  const formatExperienceCenters = (ecArray) => {
    if (!ecArray || ecArray.length === 0) return "N/A";

    const codes = ecArray.map(ec => ec?.code || ec?.name || "").filter(Boolean);
    if (codes.length === 0) return "N/A";

    const displayCodes = codes.slice(0, 2);
    const remainingCodes = codes.slice(2);

    const displayText = displayCodes.join(", ");

    if (remainingCodes.length === 0) {
      return displayText;
    }

    return (
      <span>
        {displayText}
        <StyledTooltip title={remainingCodes.join(", ")}>
          <span style={{ cursor: "pointer", color: "blue", marginLeft: "5px" }}>
            +{remainingCodes.length} more
          </span>
        </StyledTooltip>
      </span>
    );
  };

  const headers = [
    { key: "slno", label: "Sl No" },
    { key: "ticketNo", label: "Internal Ticket Id." },
    { key: "assignedTo", label: "Assigned To" },
    { key: "assignedBy", label: "Assigned By" },
    { key: "ticketCreatedDate", label: "Internal Ticket Created Date" },
    { key: "resolutionExpectedDate", label: "Resolution Expected Date" },
    { key: "daysPending", label: "Days Pending" },
    { key: "status", label: "Status" },
    { key: "CustomerName", label: "Customer Name" },
    { key: "VendorName", label: "Vendor Name" },
    { key: "ProjectNo", label: "Project No" },
    { key: "ClosingRemarks", label: "Closing Remarks" },
  ];

  const onImageChangeCheck = async (e, index) => {
    const newFiles = [...files];

    setUploading(true);
    const fd = new FormData();
    fd.append("file", e.target.files[0]);

    try {
      const fileUploadRes = await HttpService.uploadFile(fd);
      newFiles[index] = fileUploadRes.data;
      setFiles(newFiles);
    } catch (err) {
      props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
    }
    setUploading(false);
  }

  const closeCreateTicketDialog = () => {
    setOpenCreateTicketDialog(false)
  }

  // Function to handle tab changes
  const handleChange = (newValue) => {
    setRibbonTagValue(newValue);
  };

  const makeDataForCsv = (arr) => {
    let csvArrData = []
    arr.forEach((el, i) => {
      let newObj = {
        slno: i + 1,
        ticketNo: el.uniqueTicketNo || 'N/A',
        assignedTo: el.assignedTo?.name || 'N/A',
        assignedBy:
          el?.type === 'customer'
            ? `Customer - ${el?.customerCreatedBy?.name || "Unknown"} | Contact Number - ${el?.customerCreatedBy?.contact_no || "No Contact"}`
            : el?.taskCreatedBy?.name || 'N/A',
        ticketCreatedDate: el.createdAt ? moment(el.createdAt).format("DD-MM-YYYY") : 'N/A',
        resolutionExpectedDate: el.expectedClosureDate ? moment(el.expectedClosureDate).format("DD-MM-YYYY") : 'N/A',
        daysPending: el?.expectedClosureDate
          ? Math.ceil((new Date(el?.expectedClosureDate) - new Date()) / (24 * 60 * 60 * 1000))
          : "N/A",
        status: el.status || 'N/A',
        CustomerName: el?.categoryDetails?.subCategory?.CustomerName || 'N/A',
        VendorName: el?.categoryDetails?.subCategory?.vendorName || 'N/A',
        ProjectNo: el?.categoryDetails?.subCategory?.ProjectNo || 'N/A',
        ClosingRemarks: el?.logs[0]?.remarks || 'N/A',
      }
      csvArrData.push(newObj)
    })
    setCsvData(csvArrData)
  }

  // Summary data: SAME existing API + SAME filters, just fetched with a large
  // limit so the cards/donut cover ALL matching tickets, not only the current page.
  const getSummaryTickets = async (noDateArg) => {
    if (!SUMMARY_VIEWS.includes(ribbonTagValue)) {
      setSummaryTickets([]);
      return;
    }
    try {
      let dateObj = { startDate: startDate, endDate: endDate };

      if (noDateArg === "noDate") {
        dateObj.startDate = "";
        dateObj.endDate = "";
      }

      const assignedToId = selectedAssignedTo ? selectedAssignedTo.id : "";
      const sourceFilter = selectedSourceFilters.length > 0 ? selectedSourceFilters.join(',') : "";

      // ✅ NEW: Handle "View All Tickets" by fetching from all categories
      if (ribbonTagValue === "View All Tickets") {
        const allViews = [
          "Tickets Assigned To Me",
          "Customer Tickets Assigned To Me",
          "Tickets Assigned To My Team",
          "Customer Tickets Assigned To My Team",
          "Tickets Assigned By Me",
          "Tech Related Query"
        ];

        let allTickets = [];

        // Fetch from all categories
        for (const view of allViews) {
          try {
            const response = await HttpService.getFilteredTaskTickets(
              view,
              dateObj,
              selectedStatusData,
              createTicketFromNotes,
              assignedToId,
              sourceFilter,
              0,
              SUMMARY_FETCH_LIMIT
            );
            const tickets = response.data.data || response.data || [];
            allTickets = [...allTickets, ...tickets];
          } catch (err) {
            console.log(`Error fetching ${view}:`, err);
          }
        }

        // Remove duplicates based on ticket ID
        const uniqueTickets = Array.from(
          new Map(allTickets.map(ticket => [ticket._id, ticket])).values()
        );

        setSummaryTickets(uniqueTickets);
      } else {
        const response = await HttpService.getFilteredTaskTickets(
          ribbonTagValue,
          dateObj,
          selectedStatusData,
          createTicketFromNotes,
          assignedToId,
          sourceFilter,
          0,
          SUMMARY_FETCH_LIMIT
        );

        setSummaryTickets(response.data.data || response.data || []);
      }
    } catch (error) {
      console.log("Error ->", error);
    }
  };

  // getFilteredTickets - ensure it always uses passed params, not stale state
  const getFilteredTickets = async (noDateArg, pageNumber = 0, limitNumber = rowsPerPage) => {
    setTicketsLoading(true);
    try {
      let dateObj = { startDate: startDate, endDate: endDate };

      if (noDateArg === "noDate") {
        dateObj.startDate = "";
        dateObj.endDate = "";
      }

      const assignedToId = selectedAssignedTo ? selectedAssignedTo.id : "";
      const sourceFilter = selectedSourceFilters.length > 0 ? selectedSourceFilters.join(',') : "";

      let ticketsData = [];
      let totalCount = 0;
      let totalPagesCount = 1;

      // ✅ NEW: Handle "View All Tickets" by fetching from all categories
      if (ribbonTagValue === "View All Tickets") {
        const allViews = [
          "Tickets Assigned To Me",
          "Customer Tickets Assigned To Me",
          "Tickets Assigned To My Team",
          "Customer Tickets Assigned To My Team",
          "Tickets Assigned By Me",
          "Tech Related Query"
        ];

        let allTickets = [];

        // Fetch from all categories
        for (const view of allViews) {
          try {
            const response = await HttpService.getFilteredTaskTickets(
              view,
              dateObj,
              selectedStatusData,
              createTicketFromNotes,
              assignedToId,
              sourceFilter,
              0,
              SUMMARY_FETCH_LIMIT
            );
            const tickets = response.data.data || response.data || [];
            allTickets = [...allTickets, ...tickets];
          } catch (err) {
            console.log(`Error fetching ${view}:`, err);
          }
        }

        // Remove duplicates based on ticket ID
        const uniqueTickets = Array.from(
          new Map(allTickets.map(ticket => [ticket._id, ticket])).values()
        );

        // Apply pagination
        totalCount = uniqueTickets.length;
        totalPagesCount = Math.ceil(totalCount / limitNumber);
        const startIndex = pageNumber * limitNumber;
        const endIndex = startIndex + limitNumber;
        ticketsData = uniqueTickets.slice(startIndex, endIndex);
      } else {
        const response = await HttpService.getFilteredTaskTickets(
          ribbonTagValue,
          dateObj,
          selectedStatusData,
          createTicketFromNotes,
          assignedToId,
          sourceFilter,
          pageNumber,
          limitNumber
        );

        ticketsData = response.data.data || response.data;
        totalCount = response.data.totalCount || ticketsData.length;
        totalPagesCount = response.data.totalPages || 1;
      }

      // Reopened -> Pending -> Resolved -> Closed
      const STATUS_ORDER = { 'Reopen': 0, 'Pending': 1, 'Resolved': 2, 'Closed': 3 };
      const sortedData = ticketsData.sort((a, b) => {
        const aStatusOrder = STATUS_ORDER[a.status] ?? 99;
        const bStatusOrder = STATUS_ORDER[b.status] ?? 99;
        if (aStatusOrder !== bStatusOrder) return aStatusOrder - bStatusOrder;

        const aIsCustomerApp = a.source === 'Customer App';
        const bIsCustomerApp = b.source === 'Customer App';
        if (aIsCustomerApp && !bIsCustomerApp) return -1;
        if (!aIsCustomerApp && bIsCustomerApp) return 1;
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      setFetchData(sortedData);
      setTotalPages(totalPagesCount);
      setTotalCount(totalCount);
      setPage(pageNumber);
      makeDataForCsv(ticketsData);
    } catch (error) {
      console.log("Error ->", error);
    }
    setTicketsLoading(false);

    // keep the summary cards/donut in sync with the table on every refresh
    getSummaryTickets(noDateArg);
  };

  const getDataOnPageLoading = async () => {
    setBootstrapping(true);
    try {
      const assignedToId = selectedAssignedTo ? selectedAssignedTo.id : "";
      const response3 = await HttpService.getTaskRibbonNumberInfo(selectedStatusData, createTicketFromNotes, assignedToId);
      setRibbonNumberInfo(response3.data)
    } catch (error) {
      console.log("Error ->", error);
    }
    setBootstrapping(false);
  };

  const handleDateFilter = () => {
    setPage(0);
    getFilteredTickets(undefined, 0, rowsPerPage);
  };

  // get data without date filtering
  const clearFilterDate = () => {
    setStartDate("");
    setEndDate("");
    setPage(0);
    getFilteredTickets("noDate", 0, rowsPerPage);
  };

  // Clears the Assigned To / Tag Status / Source filters and the ticket-id search.
  // Uses the same existing API call - no backend change.
  const clearAssignedToFilter = () => {
    setSelectedAssignedTo(null);
    setSelectedStatusData("");
    setSelectedSourceFilters([]);
    setSearchTicketID("");
    setPage(0);
    setRefreshKey((k) => k + 1);
  };

  const viewIssue = (e, data, i) => {
    setViewIssueDialog(true);
    setViewIssueData(data);
  };

  // Row par kahin bhi click -> View Ticket dialog.
  // Buttons / links / inputs par click ignore hota hai taaki Action menu aur
  // Lead No link pehle jaise hi kaam karein.
  const handleRowClick = (e, data, i) => {
    const target = e.target;
    const interactive =
      target && typeof target.closest === "function"
        ? target.closest("button, a, input, textarea, .MuiButtonBase-root")
        : null;
    if (interactive) return;
    viewIssue(e, data, i);
  };

  const closeIssue = (e, data, i) => {
    setViewConfirmationDialog(true);
    setCloseIssueData(data);
  };

  const reopenIssue = (e, data, i) => {
    setViewReopenDialog(true);
    setReopenIssueData(data);
    setReopenRemarks("");
  };

  const resolveIssue = (e, data, i) => {
    setViewConfirmationDialog(true);
    setResolveIssueData(data);
  };

  const deleteIssue = (e, data, i) => {
    setViewDeleteConfirmationDialog(true);
    setDeleteIssueData(data);
  }

  const reassignIssue = (e, data, i) => {
    setViewReassignIssueDialog(true);
    setReassignIssueData(data);
    resetReassignPicker();
    loadDirectory();
  }

  const editIssue = (e, data, i) => {
    setEditIssueData(data);
    setViewEditIssueDialog(true);
    setEditTicketTitle(data.ticketTitle)
    setEditTicketDes(data.ticketDescription)
  }

  // ---- Single "Action" menu helpers (UI only - they call the existing handlers) ----
  const openActionMenu = (e, data, i) => {
    setActionMenuAnchorEl(e.currentTarget);
    setActionMenuRow(data);
    setActionMenuIndex(i);
  };

  const closeActionMenu = () => {
    setActionMenuAnchorEl(null);
    setActionMenuRow(null);
    setActionMenuIndex(null);
  };

  const runActionFromMenu = (actionFn) => (e) => {
    const row = actionMenuRow;
    const idx = actionMenuIndex;
    closeActionMenu();
    actionFn(e, row, idx);
  };

  // same role condition that already guarded the Reassign icon
  const canReassign =
    ribbonTagValue === "Tickets Assigned By Me" ||
    Boolean(
      userDetails?.roles.find(
        (role) =>
          role.name === ROLENAME.NaraciTechManager ||
          role.name === ROLENAME.NaraciTechUser ||
          role.name === ROLENAME.DecorpotDGMAdmin ||
          role.name === ROLENAME.DecorpotAdminManager
      )
    );

  const handleDialogClose = () => {
    setViewIssueDialog(false);
    setViewConfirmationDialog(false);
    // Left behind otherwise, so the next ticket opened this dialog with the
    // previous one's remark already in the box.
    setRemarks("");
    setConfirmFiles([]);
  };

  const MAX_CONFIRM_FILES = 10;

  // One at a time, uploaded on pick. Doing it here rather than on submit means
  // a slow upload cannot silently drop a file from the payload, and the user
  // sees it land before they commit to resolving.
  const onConfirmFilePick = async (e) => {
    const picked = Array.from(e.target.files || []);
    e.target.value = null;
    if (!picked.length) return;

    const room = MAX_CONFIRM_FILES - confirmFiles.length;
    if (room <= 0) {
      props.setSnackInfo(`You can attach up to ${MAX_CONFIRM_FILES} files.`, "warning");
      return;
    }
    const queue = picked.slice(0, room);
    if (picked.length > room) {
      props.setSnackInfo(
        `Only ${room} more ${room === 1 ? "file fits" : "files fit"} — the rest were skipped.`, "warning");
    }

    setConfirmUploading(true);
    for (const file of queue) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const res = await HttpService.uploadFile(fd);
        const url = typeof res.data === "string" ? res.data : res?.data?.Location;
        if (!url) throw new Error("No URL came back for that file");
        setConfirmFiles((prev) => [...prev, { url, name: file.name }]);
      } catch (err) {
        props.setSnackInfo(
          `${file.name} could not be uploaded${err?.message ? ` — ${err.message}` : ""}`, "error");
      }
    }
    setConfirmUploading(false);
  };

  const removeConfirmFile = (url) => {
    setConfirmFiles((prev) => prev.filter((f) => f.url !== url));
  };

  // Which ticket the confirm dialog is actually about.
  //
  // closeIssue() fills closeIssueData and resolveIssue() fills
  // resolveIssueData, but the dialog body read viewIssueData - which only
  // viewIssue() ever sets. Open Close or Resolve straight from the row menu
  // and it showed a blank ticket, or the last one you had VIEWED, while
  // Confirm acted on the right one. Chosen the same way the Confirm button
  // chooses its handler, so the two cannot disagree.
  // ---- reassign cascade ---------------------------------------------------
  // locationId and experienceCenterId are ARRAYS on a user - somebody can
  // cover two cities - so membership tests are `some`, not equality.
  const raIdOf = (v) => String((v && v._id) || v || "");
  const raIn = (list, id) => Array.isArray(list) && list.some((x) => raIdOf(x) === String(id));

  // Tech is only on the table for a ticket that is itself a Tech ticket.
  // Moving any other category to a Tech person routes work round the
  // Escalation Matrix, which is what "ERP Tech Support Tickets" exists for.
  const reassignIsTechTicket =
    reassignIssueData?.categoryDetails?.category === TECH_CATEGORY_VALUE;
  const raDepartmentOptions = reassignIsTechTicket
    ? dirDepartments
    : dirDepartments.filter((d) => d?.name !== TECH_DEPARTMENT_NAME);

  const raUsersInDept = raDept ? dirUsers.filter((u) => raIdOf(u.departmentId) === raIdOf(raDept)) : [];

  // Anchored on the CENTRE's own locationId. Deriving the city from the people
  // in it lets anyone covering two cities drag their other city's centres into
  // this one's list.
  const raDeptCentres = raDept
    ? dirCentres.filter((c) => raUsersInDept.some((u) => raIn(u.experienceCenterId, c._id)))
    : [];

  const raCityOptions = (() => {
    const seen = new Map();
    raDeptCentres.forEach((c) => {
      const loc = c.locationId;
      if (loc && loc._id && !seen.has(String(loc._id))) seen.set(String(loc._id), loc);
    });
    return Array.from(seen.values()).sort((a, b) => String(a.name).localeCompare(String(b.name)));
  })();

  const raCentreOptions = raCity
    ? raDeptCentres
      .filter((c) => raIdOf(c.locationId) === raIdOf(raCity))
      .sort((a, b) => String(a.name).localeCompare(String(b.name)))
    : [];

  const raUserOptions = raCentre
    ? raUsersInDept
      .filter((u) => raIn(u.experienceCenterId, raIdOf(raCentre)))
      // The person it is already with cannot be the person you move it to.
      .filter((u) => String(u._id) !== String(reassignIssueData?.assignedTo?._id))
      .sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")))
    : [];

  const raRoles = (u) => (u?.roles || []).map((r) => r?.name).filter(Boolean).join(", ");
  const raInitials = (name) => String(name || "")
    .trim().split(/\s+/).filter(Boolean).slice(0, 2)
    .map((w) => w[0].toUpperCase()).join("") || "?";

  // The handler still sends a single email, so the contract is unchanged.
  const pickReassignUser = (u) => {
    setRaUser(u);
    setEmailTag(u ? String(u.email || "").toLowerCase() : "");
  };

  const isCloseMode = ribbonTagValue === "Tickets Assigned By Me";
  const isCustomerTicket = ribbonTagValue === "Customer Tickets Assigned To Me";
  const confirmTarget = isCloseMode ? closeIssueData : resolveIssueData;

  const handleEditDialogClose = () => {
    setViewEditIssueDialog(false);
  };

  const handleCloseConfirm = async () => {
    setConfirming(true);
    try {
      const response = await HttpService.closeTaskticket(closeIssueData._id, {
        remarks: remarks,
        attachedFiles: confirmFiles.map((f) => f.url),
      });

      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Closed Succesfully", "Success");
        setViewConfirmationDialog(false);
        getDataOnPageLoading()
        getFilteredTickets()
        setViewConfirmationDialog(false)
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo(err.message, "Error");
    } finally {
      setConfirming(false);
      setRemarks("");
      setConfirmFiles([]);
    }
  };

  const handleResolveConfirm = async () => {
    setConfirming(true);
    try {
      const response = await HttpService.resolveTaskticket(resolveIssueData._id, {
        remarks: remarks,
        attachedFiles: confirmFiles.map((f) => f.url),
      });

      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Resolved Succesfully", "Success");
        setViewDeleteConfirmationDialog(false);
        getDataOnPageLoading()
        getFilteredTickets()
        setViewConfirmationDialog(false)
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo(err.message, "Error");
    } finally {
      setConfirming(false);
      setRemarks("");
      setConfirmFiles([]);
    }
  };

  const handleReopenConfirm = async () => {
    if (!reopenRemarks.trim()) {
      props.setSnackInfo("Please add remarks for reopening the ticket", "warning");
      return;
    }

    try {
      setActionBusy(true);
      const response = await HttpService.reopenTaskTicket(reopenIssueData._id, {
        remarks: reopenRemarks
      });

      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Reopened Successfully", "success");
        setViewReopenDialog(false);
        setReopenRemarks("");

        // Refresh the data
        getDataOnPageLoading();
        getFilteredTickets();
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo(err.response?.data?.message || "Error reopening ticket", "error");
    } finally {
      setActionBusy(false);
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await HttpService.deleteTaskTicket(deleteIssueData._id);

      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Deleted Succesfully", "Success");
        setViewConfirmationDialog(false);
        getDataOnPageLoading()
        getFilteredTickets()
        setViewDeleteConfirmationDialog(false)
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo(err.message, "Error");
    }
  };

  const onChangeTicketID = (e) => {
    setSearchTicketID(e.target.value);
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleEditConfirm = async () => {
    try {
      const obj = {
        title: editTicketTitle,
        description: editTicketDes,
        ticketId: editIssueData._id,
        newDueDate: editDueDate,
        newFollowUpDate: editFollowUpDate,
      }

      const response = await HttpService.editTaskTicketDetails(obj);

      if (response.status === 200) {
        props.setSnackInfo('Success ', 'success')
        getDataOnPageLoading();
        getFilteredTickets();
        setViewEditIssueDialog(false);
        setEditIssueData({})

        if (titleRef.current) titleRef.current.value = '';
        if (desciptionRef.current) desciptionRef.current.value = '';
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  // Was: attachedFiles.forEach(item => window.open(item)).
  //
  // A click carries ONE transient user activation, and the first window.open
  // consumes it. Every later call in that loop is popup-blocked, so a ticket
  // with five attachments opened one tab and silently dropped four - which is
  // exactly what "download all" was doing. window.open also never downloaded
  // anything; it navigated a tab to the S3 URL, and images and PDFs render
  // inline there instead of saving.
  //
  // Fetched as blobs and saved instead: no popup involved, so the count is not
  // capped, and each file lands in Downloads under its own name.
  const fileNameFromUrl = (url) => {
    try {
      const raw = new URL(url).pathname.split("/").pop();
      return decodeURIComponent(raw) || "attachment";
    } catch (e) {
      return String(url).split("/").pop().split("?")[0] || "attachment";
    }
  };

  const handleDownloadAttachments = async () => {
    const files = (viewIssueData?.attachedFiles || []).filter((f) => f && f !== "");
    if (!files.length) return;

    setDownloadingAll(true);
    setDownloadDone(0);
    let saved = 0;
    const failed = [];

    for (const url of files) {
      try {
        const res = await fetch(url, { mode: "cors", credentials: "omit" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = fileNameFromUrl(url);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
        saved += 1;
      } catch (err) {
        // Almost always the S3 bucket not allowing this origin. Falling back
        // to window.open here would be pointless: the activation is long gone
        // after the first await, so every one of them would be blocked.
        failed.push(fileNameFromUrl(url));
      }
      setDownloadDone((n) => n + 1);
    }

    setDownloadingAll(false);

    if (!failed.length) {
      props.setSnackInfo(
        `Downloaded ${saved} ${saved === 1 ? "file" : "files"}`, "success");
    } else if (!saved) {
      props.setSnackInfo(
        "The files could not be fetched for download. Open them individually from the list below.",
        "error");
    } else {
      props.setSnackInfo(
        `Downloaded ${saved} of ${files.length}. ${failed.length} could not be fetched — open ${failed.length === 1 ? "it" : "them"} from the list below.`,
        "warning");
    }
  };

  const searchByTicketId = async () => {
    setSearching(true);
    try {
      if (searchTicketID !== "") {
        const response = await HttpService.getSearchedTaskTicket(searchTicketID);
        setFetchData(response.data);
        setPage(0);
        setTotalPages(1);
        makeDataForCsv(response.data);
        if (response.data.status === 204) {
          props.setSnackInfo('No results found', "error");
        }
      }
    } catch (err) {
      console.log(err.message);
      props.setSnackInfo(err.message, "Error");
    }
    setSearching(false);
  };

  const csvDownloadHandler = async () => {
    setExporting(true);
    try {
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    setExporting(false);
  };

  const downloadExcel = () => {
    try {
      setTimeout(() => {
        csvButtonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
  };

  const redirectToCreateTicket = () => {
    setOpenCreateTicketDialog(true)
  }

  const handleReassignIssueConfirm = async () => {
    setReassigning(true);
    try {
      const response = await HttpService.changeTaskTicketAssignedUserFromEmail(reassignIssueData._id, emailTag);
      if (response.status == 200) {
        props.setSnackInfo('Success ', 'success')
        getDataOnPageLoading()
        getFilteredTickets()
        setViewReassignIssueDialog(false)
        resetReassignPicker()
      }
    }
    catch (error) {
      console.log('error is ', error);
      if (error.response.status == 400) {
        props.setSnackInfo(error.response.data, 'error')
      }
      else {
        props.setSnackInfo('Error occoured', 'error')
      }
    }
    finally {
      setReassigning(false)
    }
  }

  // Loaded the first time the reassign dialog opens - no point pulling the
  // whole directory for someone who never reassigns anything.
  const loadDirectory = async () => {
    if (dirUsers.length || dirLoading) return;
    setDirLoading(true);
    const [userRes, deptRes, ecRes] = await Promise.allSettled([
      HttpService.getAllUsersforAcess({ isActive: true }),
      HttpService.getDepartments(),
      // For its locationId: a centre's city belongs to the centre, not to
      // whoever happens to work there.
      HttpService.getExperinceCenter(),
    ]);
    const listOf = (settled) => {
      if (settled.status === "fulfilled") return Array.isArray(settled.value?.data) ? settled.value.data : [];
      // These endpoints answer 404 when their collection is empty, and axios
      // rejects on that. An empty result is not a failure.
      if (settled.reason?.response?.status === 404) return [];
      return null;
    };
    const u = listOf(userRes); if (u) setDirUsers(u); else props.setSnackInfo("Could not load the user list", "error");
    const d = listOf(deptRes); if (d) setDirDepartments(d); else props.setSnackInfo("Could not load the department list", "error");
    const e = listOf(ecRes); if (e) setDirCentres(e); else props.setSnackInfo("Could not load the experience centre list", "error");
    setDirLoading(false);
  };

  const resetReassignPicker = () => {
    // Deepest first: React 17 does not batch setState after an await, so
    // clearing a parent before its child leaves a frame where the child is
    // still set and its parent is already null.
    setRaUser(null);
    setRaCentre(null);
    setRaCity(null);
    setRaDept(null);
    setEmailTag("");
  };

  const getAssingeToTaskticketData = async () => {
    try {
      const response = await HttpService.getAssingeToTaskticket();
      if (response.status == 200) {
        setAssignToData(response.data.data)
      }
    }
    catch (error) {
      console.log('error is ', error);
      if (error.response.status == 400) {
        props.setSnackInfo(error.response.data, 'error')
      }
      else {
        props.setSnackInfo('Error occoured', 'error')
      }
    }
  }

  // Pagination from @material-ui/lab is 1-indexed; internal state stays 0-indexed.
  const handleChangePage = (event, newPage) => {
    const zeroBased = newPage - 1;
    setPage(zeroBased);
    getFilteredTickets(undefined, zeroBased, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getFilteredTickets(undefined, 0, newRowsPerPage);
  };

  const handleEditDueDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0)

    if (selectedDate >= currentDate) {
      setEditDueDate(e.target.value);
    } else {
      props.setSnackInfo("Please select a date in the present or future.", 'warning');
    }
  };


  const checkUserWithoutTeam = () => {
    // set false for executives
    const singleRoleNames = [
      "Design User", "Sales User", "Finance User", "CHM_User", "Procurement Executive",
      "Finance Executive", "BOM Executive", "Marketing User", "Factory Bom", "CRM Factory",
      "Factory CRM", "Execution User", "LnD_User", "IMOS User", "Vendor Executive",
      "TeleCaller", "Project Manager", "Factory Finance Executive", "Naraci Tech User"
    ];

    if (userDetails.roles.length === 1 && singleRoleNames.includes(userDetails.roles[0].name)) {
      setIsUserWithTeam(false);
    }
  }

  // get data on ribbon filter change
  useEffect(() => {
    setPage(0);
    getFilteredTickets(undefined, 0, rowsPerPage);
    getDataOnPageLoading();
  }, [ribbonTagValue, selectedStatusData, selectedAssignedTo, selectedSourceFilters, refreshKey]);

  useEffect(() => {
    getDataOnPageLoading();
    checkUserWithoutTeam();
    getAssingeToTaskticketData();
    fetchEscalationCategories();
    fetchTatInternalTickets();
  }, []);

  // Fetch escalation matrix entries to resolve L1-L4 names for Tech Related Query tickets
  const fetchEscalationCategories = async () => {
    try {
      const res = await HttpService.getEscalationMatrixList();
      setEscalationCategories(res?.data?.data || []);
    } catch (error) {
      console.error('Error fetching escalation matrix categories:', error);
    }
  };

  // Fetch TAT internal ticket entries (text: "L1"/"L2"/"L3"/"L4", hours: <TAT hours>)
  const fetchTatInternalTickets = async () => {
    try {
      const res = await HttpService.getTatInternalTickets();
      const data = res?.data?.data || [];
      setTatInternalTickets(data);
    } catch (error) {
      console.error('Error fetching tat internal tickets:', error);
    }
  };

  // Prefix match so "L1", "L1 (Primary Owner)", "L1 - Primary" all resolve.
  const findTatEntry = (level) => {
    return tatInternalTickets.find((t) => {
      const normalized = t.text?.trim().toUpperCase() || '';
      return normalized === level.toUpperCase() || normalized.startsWith(level.toUpperCase());
    });
  };

  const getTatHours = (level) => {
    return findTatEntry(level)?.hours ?? null;
  };

  const FALLBACK_LEVEL_BG = "#e0e0e0";
  const getTatColor = (level) => {
    return findTatEntry(level)?.color || FALLBACK_LEVEL_BG;
  };

  const getContrastTextColor = (hexColor) => {
    const hex = (hexColor || '').replace('#', '');
    if (hex.length !== 6) return '#1a1a1a';
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#1a1a1a' : '#ffffff';
  };

  const getEscalationLevelName = (queryType, level) => {
    const matchedEntry = escalationCategories.find((c) => c.text === queryType);
    return matchedEntry?.[level]?.name || "N/A";
  };

  // Business hours: Mon-Fri 10:00-19:00 only (mirrors techQueryEscalation.cron.js).
  const BUSINESS_START_HOUR = 10;
  const BUSINESS_END_HOUR = 19;

  const calculateBusinessHoursElapsed = (startDate, endDate) => {
    if (!startDate || !endDate || endDate <= startDate) return 0;

    let totalMs = 0;
    let cursor = new Date(startDate);
    const end = new Date(endDate);
    let iterations = 0;
    const MAX_ITERATIONS = 10000;

    while (cursor < end && iterations < MAX_ITERATIONS) {
      iterations++;
      const day = cursor.getDay(); // 0 = Sunday, 6 = Saturday

      if (day === 0 || day === 6) {
        cursor = new Date(cursor);
        cursor.setDate(cursor.getDate() + 1);
        cursor.setHours(BUSINESS_START_HOUR, 0, 0, 0);
        continue;
      }

      const dayStart = new Date(cursor);
      dayStart.setHours(BUSINESS_START_HOUR, 0, 0, 0);
      const dayEnd = new Date(cursor);
      dayEnd.setHours(BUSINESS_END_HOUR, 0, 0, 0);

      if (cursor < dayStart) {
        cursor = dayStart;
        continue;
      }
      if (cursor >= dayEnd) {
        cursor = new Date(cursor);
        cursor.setDate(cursor.getDate() + 1);
        cursor.setHours(BUSINESS_START_HOUR, 0, 0, 0);
        continue;
      }

      const segmentEnd = end < dayEnd ? end : dayEnd;
      totalMs += segmentEnd - cursor;
      cursor = segmentEnd;

      if (cursor.getTime() === dayEnd.getTime()) {
        cursor = new Date(cursor);
        cursor.setDate(cursor.getDate() + 1);
        cursor.setHours(BUSINESS_START_HOUR, 0, 0, 0);
      }
    }

    return totalMs / (1000 * 60 * 60);
  };

  const calculateBusinessHoursDeadline = (startDate, hoursToAdd) => {
    if (!startDate || hoursToAdd == null) return null;

    let remainingMs = hoursToAdd * 60 * 60 * 1000;
    let cursor = new Date(startDate);
    let iterations = 0;
    const MAX_ITERATIONS = 10000;

    while (remainingMs > 0 && iterations < MAX_ITERATIONS) {
      iterations++;
      const day = cursor.getDay();

      if (day === 0 || day === 6) {
        cursor = new Date(cursor);
        cursor.setDate(cursor.getDate() + 1);
        cursor.setHours(BUSINESS_START_HOUR, 0, 0, 0);
        continue;
      }

      const dayStart = new Date(cursor);
      dayStart.setHours(BUSINESS_START_HOUR, 0, 0, 0);
      const dayEnd = new Date(cursor);
      dayEnd.setHours(BUSINESS_END_HOUR, 0, 0, 0);

      if (cursor < dayStart) {
        cursor = dayStart;
        continue;
      }
      if (cursor >= dayEnd) {
        cursor = new Date(cursor);
        cursor.setDate(cursor.getDate() + 1);
        cursor.setHours(BUSINESS_START_HOUR, 0, 0, 0);
        continue;
      }

      const availableMsToday = dayEnd - cursor;
      if (remainingMs <= availableMsToday) {
        cursor = new Date(cursor.getTime() + remainingMs);
        remainingMs = 0;
      } else {
        remainingMs -= availableMsToday;
        cursor = new Date(dayEnd);
        cursor.setDate(cursor.getDate() + 1);
        cursor.setHours(BUSINESS_START_HOUR, 0, 0, 0);
      }
    }

    return cursor;
  };

  const getBusinessDeadlineDate = (ticket) => {
    if (!ticket?.createdAt) return "N/A";
    const level = ticket.currentEscalationLevel || 'L1';
    const tatHours = getTatHours(level);
    if (tatHours === null) return "N/A";
    const deadline = calculateBusinessHoursDeadline(new Date(ticket.createdAt), tatHours);
    return deadline ? moment(deadline).format("DD-MM-YYYY HH:mm") : "N/A";
  };

  // ---- Status summary (counts come from the complete filtered ticket set) ----
  const showSummary = SUMMARY_VIEWS.includes(ribbonTagValue);

  const statusSummary = useMemo(() => {
    const counts = { Pending: 0, Resolved: 0, Closed: 0, Reopen: 0 };
    (summaryTickets || []).forEach((t) => {
      if (counts[t?.status] !== undefined) counts[t.status] += 1;
    });
    const total = STATUS_META.reduce((sum, m) => sum + counts[m.key], 0);
    const segments = STATUS_META.map((m) => ({
      ...m,
      value: counts[m.key],
      percent: total ? Math.round((counts[m.key] / total) * 100) : 0,
    }));
    return { segments, total };
  }, [summaryTickets]);

  const STAT_ICONS = {
    Pending: <ScheduleRoundedIcon fontSize="small" />,
    Resolved: <CheckCircleRoundedIcon fontSize="small" />,
    Closed: <LockRoundedIcon fontSize="small" />,
    Reopen: <RepeatIcon fontSize="small" />,
  };

  // Status pill (display only - status values themselves are untouched)
  const renderStatusPill = (status) => {
    const meta = STATUS_META.find((m) => m.key === status);
    return (
      <span
        className={classes.pill}
        style={{
          backgroundColor: meta?.pillBg || "#EEF1F6",
          color: meta?.pillText || "#4A5C77",
        }}
      >
        {status || "N/A"}
      </span>
    );
  };

  // Days-pending coloring: overdue (<= 0) red, due soon (1-3) amber, otherwise green.
  const daysPendingColor = (days) => {
    if (typeof days !== "number" || Number.isNaN(days)) return "#2D3C55";
    if (days <= 0) return "#D93025";
    if (days <= 3) return "#E08A00";
    return "#12A66E";
  };

  const rangeStart = totalCount === 0 ? 0 : page * rowsPerPage + 1;
  const rangeEnd = Math.min((page + 1) * rowsPerPage, totalCount);
  const pageCount = Math.max(1, Math.ceil(totalCount / rowsPerPage));

  const personCell = (name, extra) => (
    <div className={classes.personCell}>
      <Avatar className={classes.avatar}>{getInitials(name)}</Avatar>
      <div style={{ textAlign: "left" }}>
        <div>{name || "N/A"}</div>
        {extra}
      </div>
    </div>
  );

  const viewCount = (value) => {
    const n = ribbonNumberInfo || {};
    switch (value) {
      case "View All Tickets":
        return (n.customerToMe || 0) + (n.toMe || 0) + (n.customerToTeam || 0)
          + (n.toTeam || 0) + (n.byMe || 0) + (n.techQuery || 0);
      case "Customer Tickets Assigned To Me": return n.customerToMe || 0;
      case "Customer Tickets Assigned To My Team": return n.customerToTeam || 0;
      case "Tickets Assigned To Me": return n.toMe || 0;
      case "Tickets Assigned To My Team": return n.toTeam || 0;
      case "Tickets Assigned By Me": return n.byMe || 0;
      case "Tech Related Query": return n.techQuery || 0;
      default: return 0;
    }
  };

  // What the bar is waiting on, in the order that matters: a write outranks a
  // read. A bar with no caption only says "wait"; this says what for.
  const activity = actionBusy
    ? "Saving your change and notifying the people on this ticket…"
    : uploading
      ? "Uploading your attachment…"
      : exporting
        ? "Building the CSV — this reads every matching ticket, so give it a moment…"
        : searching
          ? "Looking up that ticket ID…"
          : bootstrapping
            ? "Loading your dashboard — tickets, counts and assignees…"
            : ticketsLoading
              ? "Fetching tickets…"
              : "";

  return (
    <Fragment>
      <div className={classes.page}>

        {/* Driven by ANY in-flight request, with a caption naming which. */}
        <div className={classes.progressSlot}>{activity ? <BrandLinearProgress /> : null}</div>
        <div className={classes.activityRow}>
          {activity && (
            <>
              <CircularProgress size={12} thickness={5} style={{ color: ORANGE }} />
              {activity}
            </>
          )}
        </div>


        {/* ---- Page heading + primary action ---- */}
        <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: 18 }}>
          <Grid item>
            <div className={classes.pageTitle}>Task Management Dashboard</div>
            <div className={classes.pageSubTitle}>
              Track, manage and resolve internal &amp; customer tickets efficiently.
            </div>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              startIcon={<AddRoundedIcon />}
              onClick={redirectToCreateTicket}
              className={classes.createButton}
            >
              Create Internal Ticket
            </Button>
          </Grid>
        </Grid>

        {/* ---- Date filter card ---- */}
        <div className={classes.card}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} sm={6} md={3}>
              <span className={classes.fieldLabel}>Start Date</span>
              <TextField
                id="startDate"
                name="startDate"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                variant="outlined"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <span className={classes.fieldLabel}>End Date</span>
              <TextField
                id="endDate"
                name="endDate"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                variant="outlined"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                disabled={!startDate || !endDate}
                onClick={handleDateFilter}
                className={classes.submitButton}
              >
                Submit
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={clearFilterDate}
                className={classes.clearButton}
              >
                Clear Filter
              </Button>
            </Grid>
          </Grid>
        </div>

        {/* ---- Search + view/status/assignee/source filters + CSV ---- */}
        <div className={classes.card}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} md={3}>
              <TextField
                id="ticketIdSearch"
                name="ticketIdSearch"
                placeholder="Search by Ticket ID..."
                variant="outlined"
                size="small"
                fullWidth
                value={searchTicketID}
                onChange={onChangeTicketID}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && searchTicketID !== "") searchByTicketId();
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        size="small"
                        onClick={searchByTicketId}
                        disabled={searchTicketID === ""}
                      >
                        <SearchRoundedIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <span className={classes.fieldLabel}>Ticket View</span>
              <FormControl variant="outlined" size="small" fullWidth>
                <Select
                  value={ribbonTagValue}
                  onChange={(e) => handleChange(e.target.value)}
                  // Without this the closed field showed the raw MenuItem -
                  // label and count crammed together with no space, and the
                  // long ones ("Customer Tickets Assigned to My Team(12)")
                  // ran straight off the end of the box.
                  renderValue={(value) => {
                    const v = TICKET_VIEWS.find((o) => o.value === value);
                    return (
                      <span className={classes.viewValue}>
                        <span className={classes.viewValueText}>{v ? v.label : value}</span>
                        <span className={classes.viewCount}>{viewCount(value)}</span>
                      </span>
                    );
                  }}
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                    PaperProps: { className: classes.viewMenuPaper },
                  }}
                >
                  {TICKET_VIEWS.map((o) => {
                    if (o.teamOnly && !isUserWithTeam) return null;
                    if (o.group) {
                      return (
                        <ListSubheader key={o.group} disableSticky className={classes.viewGroup}>
                          {o.group}
                        </ListSubheader>
                      );
                    }
                    const count = viewCount(o.value);
                    return (
                      <MenuItem key={o.value} value={o.value} className={classes.viewItem}>
                        <span className={classes.viewItemMain}>
                          <o.Icon className={classes.viewItemIcon} />
                          <span className={classes.viewItemText}>{o.label}</span>
                        </span>
                        {/* The count as its own chip, right-aligned, so the
                            numbers line up down the list instead of floating
                            wherever each label happens to end. */}
                        <span className={count ? classes.viewItemCount : classes.viewItemCountZero}>
                          {count}
                        </span>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <span className={classes.fieldLabel}>Tag Status</span>
              <Autocomplete
                value={selectedStatusData}
                key="selectedStatusData"
                onChange={(e, newValue) => setSelectedStatusData(newValue)}
                options={categoryData}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Status" fullWidth variant="outlined" size="small" />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <span className={classes.fieldLabel}>Assigned To</span>
              <Autocomplete
                value={selectedAssignedTo}
                key="selectedAssignedTo"
                onChange={(e, newValue) => setSelectedAssignedTo(newValue)}
                options={AssignToData}
                getOptionLabel={(option) => option?.name || ""}
                getOptionSelected={(option, value) => option?.id === value?.id}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Filter by Assigned To" fullWidth variant="outlined" size="small" />
                )}
              />
            </Grid>

            {/* Clears assignee / status / source / search - same API, no backend change */}
            <Grid item>
              <Button
                variant="outlined"
                onClick={clearAssignedToFilter}
                className={classes.clearButton}
              >
                Clear
              </Button>
            </Grid>

            {ribbonTagValue.includes("Customer") && (
              <Grid item xs={12} sm={6} md={2}>
                <span className={classes.fieldLabel}>Source</span>
                <Autocomplete
                  multiple
                  value={selectedSourceFilters}
                  onChange={(e, newValue) => setSelectedSourceFilters(newValue)}
                  options={sourceFilterOptions}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Source" fullWidth variant="outlined" size="small" />
                  )}
                />
              </Grid>
            )}

            <Grid item>
              <CSVLink
                headers={headers}
                filename={ribbonTagValue + ".csv"}
                data={csvData}
                ref={csvButtonRef}
              />
              <Button
                onClick={csvDownloadHandler}
                startIcon={<GetAppRoundedIcon />}
                variant="contained"
                className={classes.csvButton}
              >
                Download CSV
              </Button>
            </Grid>
          </Grid>
        </div>

        {/* ---- Status summary: counts/percentages/donut from the existing API data ---- */}
        {showSummary && (
          <div className={classes.card} style={{ padding: "20px 24px" }}>
            <Grid container alignItems="center" style={{ marginBottom: 18 }}>
              <PeopleAltRoundedIcon style={{ color: "#2F7BEF", fontSize: 34, marginRight: 12 }} />
              <div>
                <div className={classes.summaryTitle}>{SUMMARY_VIEW_LABELS[ribbonTagValue]}</div>
                <div className={classes.summarySubTitle}>Ticket status summary for the selected period</div>
              </div>
            </Grid>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  {statusSummary.segments.map((s) => (
                    <Grid item xs={6} sm={3} key={s.key}>
                      <div className={classes.statCard} style={{ backgroundColor: s.soft, borderColor: s.border }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div className={classes.statIconBox} style={{ backgroundColor: s.color }}>
                            {STAT_ICONS[s.key]}
                          </div>
                          <span className={classes.statLabel}>{s.key}</span>
                        </div>
                        <div className={classes.statValue}>{s.value}</div>
                        <div className={classes.statPercent}>{s.percent}% of total</div>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} md={3} style={{ textAlign: "center" }}>
                <TicketDonutChart segments={statusSummary.segments} total={statusSummary.total} />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                {statusSummary.segments.map((s) => (
                  <div className={classes.legendRow} key={s.key}>
                    <span className={classes.legendDot} style={{ backgroundColor: s.color }} />
                    <span className={classes.legendLabel}>{s.key}</span>
                    <span className={classes.legendValue}>{s.value} ({s.percent}%)</span>
                  </div>
                ))}
              </Grid>
            </Grid>
          </div>
        )}

        {/* ---- Ticket table ---- */}
        {fetchData && (
          <div className={classes.tableCard}>
            <TableContainer className={classes.tableScroll}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  {ribbonTagValue === "Tech Related Query" ? (
                    <>
                      <TableRow key='tableHeadersRow1'>
                        <StyledTableCell rowSpan={2}>Sl. No.</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Internal Ticket Id.</StyledTableCell>
                        <StyledTableCell rowSpan={2} style={{ width: '22%' }}>Ticket Title</StyledTableCell>
                        <StyledTableCell colSpan={4}>Assign to</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Assigned by</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Created On</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Reassign Date</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Due Date</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Escalation Due</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Days Pending</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Status</StyledTableCell>
                        <StyledTableCell rowSpan={2}>Action</StyledTableCell>
                      </TableRow>
                      {/* MUI's stickyHeader puts `top: 0` on EVERY header
                          cell, so this second row would stick on top of the
                          first and hide it. 46px is row one: 13px text with
                          14px padding top and bottom. */}
                      <TableRow key='tableHeadersRow2' className={classes.stickySecondRow}>
                        <StyledTableCell>L1<br />(Primary Owner)<br />{getTatHours('L1') !== null ? `TAT- ${getTatHours('L1')} Hrs` : 'TAT- N/A'}</StyledTableCell>
                        <StyledTableCell>L2<br />(Secondary Owner)<br />{getTatHours('L2') !== null ? `TAT- ${getTatHours('L2')} Hrs` : 'TAT- N/A'}</StyledTableCell>
                        <StyledTableCell>L3<br />(Tertiary Owner)<br />{getTatHours('L3') !== null ? `TAT- ${getTatHours('L3')} Hrs` : 'TAT- N/A'}</StyledTableCell>
                        <StyledTableCell>L4<br />(Escalation)<br />{getTatHours('L4') !== null ? `TAT- ${getTatHours('L4')} Hrs` : 'TAT- N/A'}</StyledTableCell>
                      </TableRow>
                    </>
                  ) : (
                    <TableRow key='tableHeaders'>
                      <StyledTableCell>Sl No</StyledTableCell>
                      <StyledTableCell>Internal Ticket Id.</StyledTableCell>
                      <StyledTableCell style={{ width: '22%' }}>Ticket Title</StyledTableCell>
                      <StyledTableCell>Assigned To</StyledTableCell>
                      <StyledTableCell>Assigned By</StyledTableCell>
                      {ribbonTagValue.includes("Customer") && <StyledTableCell>Source</StyledTableCell>}
                      <StyledTableCell>Created On</StyledTableCell>
                      <StyledTableCell>Reassign Date</StyledTableCell>
                      {!ribbonTagValue.includes("Customer") && <StyledTableCell>Due Date</StyledTableCell>}
                      {!(ribbonTagValue === "Closed") && <StyledTableCell>Days Pending</StyledTableCell>}
                      <StyledTableCell>Status</StyledTableCell>
                      <StyledTableCell>Action</StyledTableCell>
                    </TableRow>
                  )}
                </TableHead>
                <TableBody>
                  {/* colSpan is deliberately larger than any header variant -
                      this table has two of them, with different rowSpan/colSpan
                      layouts, and a browser clamps an over-wide colSpan to the
                      real width. */}
                  {ticketsLoading && (
                    [0, 1, 2, 3, 4].map((r) => (
                      <TableRow key={`sk-${r}`}>
                        <StyledTableCell colSpan={24} style={{ padding: "8px 16px" }}>
                          <Skeleton variant="rect" height={22} style={{ borderRadius: 6 }} />
                        </StyledTableCell>
                      </TableRow>
                    ))
                  )}

                  {!ticketsLoading && !fetchData?.length && (
                    <TableRow>
                      <StyledTableCell colSpan={24} className={classes.emptyCell}>
                        <InboxRoundedIcon style={{ fontSize: 42, color: "#C9D3E4" }} />
                        <div className={classes.emptyTitle}>No tickets here</div>
                        <div className={classes.emptyHint}>
                          {startDate || endDate || searchTicketID || selectedStatusData || selectedAssignedTo
                            ? "Nothing matches the filters above — try widening the dates or clearing a filter."
                            : `Nothing is in "${ribbonTagValue}" yet.`}
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  )}

                  {!ticketsLoading && fetchData?.map((data, i) => {
                    const daysPending = data?.expectedClosureDate
                      ? Math.ceil((new Date(data?.expectedClosureDate) - new Date()) / (24 * 60 * 60 * 1000))
                      : null;
                    const customerDaysPending = data?.createdAt
                      ? Math.ceil((new Date(data?.createdAt) - new Date()) / (24 * 60 * 60 * 1000))
                      : null;

                    return (
                      <StyledTableRow
                        key={i}
                        hover
                        onClick={(e) => handleRowClick(e, data, i)}
                        title="Click to view ticket"
                      >
                        <StyledTableCell style={{ textAlign: "center" }}>
                          {page * rowsPerPage + i + 1}
                        </StyledTableCell>

                        <StyledTableCell style={{ textAlign: "center" }}>
                          <span className={classes.ticketId}>{data?.uniqueTicketNo || "N/A"}</span>
                        </StyledTableCell>

                        <StyledTableCell style={{ textAlign: "left" }}>
                          {data?.ticketTitle || "N/A"}
                        </StyledTableCell>

                        {ribbonTagValue === "Tech Related Query" ? (
                          <>
                            <StyledTableCell style={{ textAlign: "center", backgroundColor: getTatColor('L1'), color: getContrastTextColor(getTatColor('L1')) }}>
                              {getEscalationLevelName(data?.categoryDetails?.subCategory?.QueryType, 'l1User')}
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: "center", backgroundColor: getTatColor('L2'), color: getContrastTextColor(getTatColor('L2')) }}>
                              {getEscalationLevelName(data?.categoryDetails?.subCategory?.QueryType, 'l2User')}
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: "center", backgroundColor: getTatColor('L3'), color: getContrastTextColor(getTatColor('L3')) }}>
                              {getEscalationLevelName(data?.categoryDetails?.subCategory?.QueryType, 'l3User')}
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: "center", backgroundColor: getTatColor('L4'), color: getContrastTextColor(getTatColor('L4')) }}>
                              {getEscalationLevelName(data?.categoryDetails?.subCategory?.QueryType, 'l4User')}
                            </StyledTableCell>
                          </>
                        ) : (
                          <StyledTableCell>
                            {personCell(
                              data?.assignedTo?.name,
                              <div style={{ fontSize: 11, color: MUTED }}>
                                EC - {formatExperienceCenters(data?.assignedTo?.experienceCenterId)}
                              </div>
                            )}
                          </StyledTableCell>
                        )}

                        <StyledTableCell>
                          {personCell(
                            data?.type === "customer"
                              ? `Customer - ${data?.customerCreatedBy?.name || "Unknown"}`
                              : data?.taskCreatedBy?.name,
                            data?.type === "customer" ? (
                              <>
                                <div style={{ fontSize: 11, color: MUTED }}>
                                  Mobile - {data?.customerCreatedBy?.contact_no || "No Contact"}
                                </div>
                                <div style={{ fontSize: 11 }}>
                                  Lead No -{" "}
                                  <Link
                                    to={`/project-logs/${data?.leadId?._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ textDecoration: "underline", cursor: "pointer", color: "#1976d2" }}
                                  >
                                    {data?.leadId?.lead_no}
                                  </Link>
                                </div>
                              </>
                            ) : null
                          )}
                        </StyledTableCell>

                        {ribbonTagValue.includes("Customer") && (
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {data?.source || "N/A"}
                          </StyledTableCell>
                        )}

                        <StyledTableCell style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                          {data?.createdAt
                            ? moment.utc(data?.createdAt).local().format("DD-MM-YYYY HH:mm")
                            : "-"}
                        </StyledTableCell>

                        <StyledTableCell style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                          {data?.reassignDate
                            ? moment.utc(data?.reassignDate).local().format("DD-MM-YYYY HH:mm")
                            : "-"}
                        </StyledTableCell>

                        {!ribbonTagValue.includes("Customer") && (
                          <StyledTableCell style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                            {data?.expectedClosureDate
                              ? moment(data?.expectedClosureDate).utc().format("DD-MM-YYYY")
                              : "-"}
                          </StyledTableCell>
                        )}

                        {ribbonTagValue === "Tech Related Query" && (
                          <StyledTableCell style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                            {getBusinessDeadlineDate(data)}
                          </StyledTableCell>
                        )}

                        {!(ribbonTagValue === "Closed") && !ribbonTagValue.includes("Customer") && (
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {daysPending !== null ? (
                              <span style={{ color: daysPendingColor(daysPending), fontWeight: 600 }}>
                                {daysPending}
                              </span>
                            ) : (
                              "N/A"
                            )}
                          </StyledTableCell>
                        )}

                        {!(ribbonTagValue === "Closed") && ribbonTagValue.includes("Customer") && (
                          <StyledTableCell style={{ textAlign: "center" }}>
                            {customerDaysPending !== null ? (
                              <span style={{ color: daysPendingColor(customerDaysPending), fontWeight: 600 }}>
                                {customerDaysPending}
                              </span>
                            ) : (
                              "N/A"
                            )}
                          </StyledTableCell>
                        )}

                        <StyledTableCell style={{ textAlign: "center" }}>
                          {renderStatusPill(data?.status)}
                        </StyledTableCell>

                        {/* Action cell stops the row click so the menu opens on its own */}
                        <StyledTableCell
                          style={{ textAlign: "center" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {/* Settings Icon on Action button */}
                          {/* A gear reads as "settings", not "things you can
                              do to this row". A labelled chevron does. */}
                          <Button
                            size="small"
                            endIcon={<ExpandMoreRoundedIcon style={{ fontSize: 17 }} />}
                            onClick={(e) => openActionMenu(e, data, i)}
                            className={classes.actionTrigger}
                          >
                            Actions
                          </Button>
                        </StyledTableCell>

                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {/* ---- Pagination (same handlers, screenshot styling) ---- */}
            <div className={classes.paginationBar}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span className={classes.paginationText}>Rows per page:</span>
                <FormControl variant="outlined" size="small">
                  <NativeSelect
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    inputProps={{ 'aria-label': 'rows per page' }}
                  >
                    {[20, 50, 100, 250, 500].map((opt) => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </NativeSelect>
                </FormControl>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                <span className={classes.paginationText}>
                  {rangeStart}-{rangeEnd} of {totalCount}
                </span>
                <Pagination
                  count={pageCount}
                  page={page + 1}
                  onChange={handleChangePage}
                  color="primary"
                  shape="rounded"
                  siblingCount={1}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Action menu - every item calls the SAME handler the icon used to call,
          with the SAME visibility conditions as before. */}
      <Menu
        anchorEl={actionMenuAnchorEl}
        open={Boolean(actionMenuAnchorEl)}
        onClose={closeActionMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ className: classes.actionMenuPaper }}
      >
        {/* Same handlers and the same visibility conditions as before - only
            the icon, wording and colour of each row changed. */}
        {actionMenuRow && (
          <MenuItem className={classes.actionItem} onClick={runActionFromMenu(viewIssue)}>
            <span className={classes.actionIcon} style={{ background: "#E8F6EE", color: "#1F7A4D" }}>
              <VisibilityRoundedIcon style={{ fontSize: 17 }} />
            </span>
            <span className={classes.actionText}>
              <span className={classes.actionLabel}>View ticket</span>
              <span className={classes.actionHint}>Description, attachments and remarks</span>
            </span>
          </MenuItem>
        )}

        {actionMenuRow &&
          (ribbonTagValue === "Tickets Assigned To Me" ||
            ribbonTagValue === "Customer Tickets Assigned To Me") &&
          !(actionMenuRow?.status === "Closed" || actionMenuRow?.status === "Resolved") && (
            <MenuItem className={classes.actionItem} onClick={runActionFromMenu(resolveIssue)}>
              <span className={classes.actionIcon} style={{ background: "#EEF3FC", color: "#1F5FB8" }}>
                <CheckCircleOutlineIcon style={{ fontSize: 17 }} />
              </span>
              <span className={classes.actionText}>
                <span className={classes.actionLabel}>Mark resolved</span>
                <span className={classes.actionHint}>Sends it back to whoever raised it</span>
              </span>
            </MenuItem>
          )}

        {actionMenuRow &&
          ribbonTagValue === "Tickets Assigned By Me" &&
          actionMenuRow?.status === "Resolved" && (
            <MenuItem className={classes.actionItem} onClick={runActionFromMenu(closeIssue)}>
              {/* Was the same blue CenterFocusWeak icon as Resolve - two
                  different actions wearing one face. */}
              <span className={classes.actionIcon} style={{ background: "#E8F4F6", color: "#13697A" }}>
                <LockOutlinedIcon style={{ fontSize: 17 }} />
              </span>
              <span className={classes.actionText}>
                <span className={classes.actionLabel}>Close ticket</span>
                <span className={classes.actionHint}>Ends it for everyone on it</span>
              </span>
            </MenuItem>
          )}

        {actionMenuRow &&
          ribbonTagValue === "Tickets Assigned By Me" &&
          actionMenuRow?.status === "Resolved" && (
            <MenuItem className={classes.actionItem} onClick={runActionFromMenu(reopenIssue)}>
              <span className={classes.actionIcon} style={{ background: "#FEF3D7", color: "#8A6100" }}>
                <ReplayIcon style={{ fontSize: 17 }} />
              </span>
              <span className={classes.actionText}>
                <span className={classes.actionLabel}>Reopen</span>
                <span className={classes.actionHint}>Put it back with the owner</span>
              </span>
            </MenuItem>
          )}

        {actionMenuRow && ribbonTagValue === "Tickets Assigned By Me" && (
          <MenuItem className={classes.actionItem} onClick={runActionFromMenu(editIssue)}>
            {/* Was red[500] - the same colour as Delete, so an edit looked as
                severe as destroying the ticket. */}
            <span className={classes.actionIcon} style={{ background: "#EDF0F5", color: NAVY }}>
              <EditOutlinedIcon style={{ fontSize: 17 }} />
            </span>
            <span className={classes.actionText}>
              <span className={classes.actionLabel}>Edit details</span>
              <span className={classes.actionHint}>Title, description or due date</span>
            </span>
          </MenuItem>
        )}

        {actionMenuRow && canReassign && (
          <MenuItem className={classes.actionItem} onClick={runActionFromMenu(reassignIssue)}>
            {/* RepeatIcon reads as "repeat", not "hand to someone else". */}
            <span className={classes.actionIcon} style={{ background: "#FEF1EA", color: ORANGE_DARK_TM }}>
              <SwapHorizRoundedIcon style={{ fontSize: 17 }} />
            </span>
            <span className={classes.actionText}>
              <span className={classes.actionLabel}>Reassign</span>
              <span className={classes.actionHint}>Move it to someone else</span>
            </span>
          </MenuItem>
        )}

        {actionMenuRow && ribbonTagValue === "Tickets Assigned By Me" && [
          <Divider key="deleteDivider" className={classes.actionDivider} />,
          <MenuItem key="deleteAction" className={classes.actionItemDanger} onClick={runActionFromMenu(deleteIssue)}>
            <span className={classes.actionIcon} style={{ background: "#FBE9E7", color: "#8C1D18" }}>
              <DeleteOutlineRoundedIcon style={{ fontSize: 17 }} />
            </span>
            <span className={classes.actionText}>
              <span className={classes.actionLabel} style={{ color: "#8C1D18" }}>Delete ticket</span>
              <span className={classes.actionHint}>Cannot be undone</span>
            </span>
          </MenuItem>,
        ]}
      </Menu>

      <Fragment>
        <Dialog
          open={viewIssueDialog}
          keepMounted
          onClose={handleDialogClose}
          maxWidth="md"
          fullWidth
          PaperProps={{ className: classes.viewPaper }}
          aria-labelledby="view-ticket-title"
        >
          <div className={classes.viewHead}>
            <span className={classes.confirmHeadIcon}>
              <DescriptionRoundedIcon style={{ fontSize: 20 }} />
            </span>
            <div style={{ minWidth: 0, flexGrow: 1 }}>
              {/* The ticket number was nowhere on this dialog - it is the one
                  thing people quote to each other about a ticket. */}
              <div className={classes.viewTicketNo}>
                {viewIssueData?.uniqueTicketNo || "Ticket"}
              </div>
              <div id="view-ticket-title" className={classes.viewTitle}>
                {viewIssueData?.ticketTitle || "Untitled ticket"}
              </div>
            </div>
            <IconButton size="small" onClick={handleDialogClose} className={classes.viewClose}>
              <CloseRoundedIcon style={{ fontSize: 19 }} />
            </IconButton>
          </div>

          <div className={classes.viewMeta}>
            {viewIssueData?.status && (
              <span className={classes.viewMetaItem}>{renderStatusPill(viewIssueData.status)}</span>
            )}
            {viewIssueData?.assignedTo?.name && (
              <span className={classes.viewChip}>
                <PersonRoundedIcon style={{ fontSize: 14 }} />
                {viewIssueData.assignedTo.name}
              </span>
            )}
            {viewIssueData?.createdAt && (
              <span className={classes.viewChip}>
                Raised {moment.utc(viewIssueData.createdAt).local().format("DD MMM YYYY, HH:mm")}
              </span>
            )}
            {viewIssueData?.expectedClosureDate && (
              <span className={classes.viewChip}>
                Due {moment.utc(viewIssueData.expectedClosureDate).local().format("DD MMM YYYY")}
              </span>
            )}
            {viewIssueData?.categoryDetails?.category && (
              <span className={classes.viewChip}>{viewIssueData.categoryDetails.category}</span>
            )}
          </div>

          <div className={classes.viewBody}>
            <div>
              <div className={classes.viewSectionLabel}>Description</div>
              <div
                className={classes.viewDescription}
                dangerouslySetInnerHTML={{ __html: viewIssueData.ticketDescription || '<em>No description was given.</em>' }}
              />
            </div>

            {/* Rendered only when there is something to show - the grid used
                to render empty, leaving a gap that looked like a failed load.
                Non-image files were invisible entirely; they are listed now. */}
            {viewIssueData?.attachedFiles?.length > 0 && (() => {
              // Empty strings have always been stored in attachedFiles; they
              // inflated the count badge and rendered as broken thumbnails.
              const files = viewIssueData.attachedFiles.filter((f) => f && f !== "");
              if (!files.length) return null;
              const isImage = (f) => /\.(jpg|jpeg|png|gif|webp)$/i.test(String(f));
              const images = files.filter(isImage);
              const others = files.filter((f) => !isImage(f));
              return (
                <div>
                  <div className={classes.viewSectionLabel}>
                    Attachments
                    <span className={classes.viewCount}>{files.length}</span>
                    <Button
                      size="small"
                      className={classes.downloadBtn}
                      startIcon={downloadingAll
                        ? <CircularProgress size={13} thickness={5} style={{ color: ORANGE_DARK_TM }} />
                        : <GetAppRoundedIcon style={{ fontSize: 16 }} />}
                      onClick={handleDownloadAttachments}
                      disabled={downloadingAll}
                    >
                      {downloadingAll
                        ? `Downloading ${downloadDone} of ${files.length}…`
                        : "Download all"}
                    </Button>
                  </div>

                  {images.length > 0 && (
                    <ImageList rowHeight={150} cols={3} className={classes.viewImages}>
                      {images.map((item) => (
                        <ImageListItem key={item} cols={1}>
                          <a href={item} target="_blank" rel="noopener noreferrer">
                            <img src={item} alt="attachment" />
                          </a>
                        </ImageListItem>
                      ))}
                    </ImageList>
                  )}

                  {others.length > 0 && (
                    <div className={classes.fileList}>
                      {others.map((f) => (
                        <a
                          key={f}
                          href={f}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={classes.fileChip}
                        >
                          <InsertDriveFileRoundedIcon style={{ fontSize: 15 }} />
                          {String(f).split('/').pop().split('?')[0] || 'Attachment'}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              );
            })()}

            <div>
              <div className={classes.viewSectionLabel}>
                Remarks
                {viewIssueData?.logs?.length > 0 && (
                  <span className={classes.viewCount}>{viewIssueData.logs.length}</span>
                )}
              </div>

              {viewIssueData?.logs?.length > 0 ? (
                <div className={classes.timeline}>
                  {viewIssueData.logs.map((log, i) => (
                    <div key={i} className={classes.timelineItem}>
                      <span className={classes.timelineAvatar}>
                        {String(log?.createdBy?.name || '?').trim().split(/\s+/).slice(0, 2)
                          .map((w) => w[0]).join('').toUpperCase() || '?'}
                      </span>
                      <div style={{ minWidth: 0, flexGrow: 1 }}>
                        <div className={classes.timelineHead}>
                          <span className={classes.timelineWho}>{log?.createdBy?.name || 'Unknown'}</span>
                          <span className={classes.timelineWhen}>
                            {/* .local(), not .utc(). The old table printed the
                                UTC date, which in IST shows the previous day
                                for anything written after 5:30pm. */}
                            {log?.createdOn
                              ? moment.utc(log.createdOn).local().format("DD MMM YYYY, HH:mm")
                              : '-'}
                          </span>
                        </div>
                        <div
                          className={classes.timelineBody}
                          dangerouslySetInnerHTML={{ __html: log?.remarks || '<em>No remark</em>' }}
                        />
                        {/* Proof filed with this remark - what was attached
                            when the ticket was resolved or closed. */}
                        {log?.attachedFiles?.filter((f) => f).length > 0 && (
                          <div className={classes.logFiles}>
                            {log.attachedFiles.filter((f) => f).map((f) => (
                              <a
                                key={f}
                                className={classes.logFile}
                                href={f}
                                target="_blank"
                                rel="noopener noreferrer"
                                title={fileNameFromUrl(f)}
                              >
                                <InsertDriveFileRoundedIcon style={{ fontSize: 14, color: "#5D6B82" }} />
                                <span className={classes.logFileName}>{fileNameFromUrl(f)}</span>
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className={classes.viewEmpty}>No remarks on this ticket yet.</div>
              )}
            </div>
          </div>
        </Dialog>
      </Fragment>

      <Fragment>
        <Dialog
          open={viewConfirmationDialog}
          keepMounted
          onClose={confirming ? undefined : handleDialogClose}
          maxWidth="xs"
          fullWidth
          PaperProps={{ className: classes.confirmPaper }}
          aria-labelledby="confirm-dialog-title"
        >
          <div className={classes.confirmHead}>
            <span className={classes.confirmHeadIcon}>
              {isCloseMode
                ? <LockOutlinedIcon style={{ fontSize: 20 }} />
                : <CheckCircleOutlineIcon style={{ fontSize: 20 }} />}
            </span>
            <div style={{ minWidth: 0 }}>
              {/* The old title said "Confirmation" for all three paths. Which
                  one is about to happen is the single most useful thing this
                  box can say. */}
              <div id="confirm-dialog-title" className={classes.confirmTitle}>
                {isCloseMode
                  ? "Close this ticket?"
                  : isCustomerTicket
                    ? "Resolve this customer ticket?"
                    : "Resolve this ticket?"}
              </div>
              <div className={classes.confirmSub}>
                {isCloseMode
                  ? "Closing ends the ticket for everyone on it."
                  : "Marking it resolved sends it back to whoever raised it."}
              </div>
            </div>
          </div>

          {/* Reserved height, so the body does not jump when it appears. */}
          <div style={{ height: 3 }}>
            {confirming && <LinearProgress className={classes.confirmBar} />}
          </div>

          <div className={classes.confirmBody}>
            <div className={classes.ticketCard}>
              <div className={classes.ticketRow}>
                <span className={classes.ticketLabel}>Ticket ID</span>
                <span className={classes.ticketIdText}>
                  {confirmTarget?.uniqueTicketNo || "—"}
                </span>
              </div>
              <div className={classes.ticketRow} style={{ alignItems: "flex-start" }}>
                <span className={classes.ticketLabel}>Title</span>
                <span className={classes.ticketTitleText}>
                  {confirmTarget?.ticketTitle || "—"}
                </span>
              </div>
            </div>

            <TextField
              id="remarks"
              name="remarks"
              label="Remarks"
              value={remarks}
              onChange={handleRemarksChange}
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={3}
              disabled={confirming}
              placeholder={isCloseMode
                ? "Why is this being closed?"
                : "What was done to resolve it?"}
              InputLabelProps={{ shrink: true }}
              helperText="Optional, but it is what the other side reads first."
            />

            {/* Proof of the work. Sits with the remark because it is read as
                part of it - the timeline shows the two together. */}
            <div>
              <div className={classes.proofHead}>
                <span className={classes.proofLabel}>
                  Attach proof
                  {confirmFiles.length > 0 && (
                    <span className={classes.viewCount}>{confirmFiles.length}</span>
                  )}
                </span>
                <Button
                  size="small"
                  component="label"
                  className={classes.attachBtn}
                  disabled={confirming || confirmUploading || confirmFiles.length >= MAX_CONFIRM_FILES}
                  startIcon={confirmUploading
                    ? <CircularProgress size={13} thickness={5} style={{ color: ORANGE_DARK_TM }} />
                    : <AttachFileRoundedIcon style={{ fontSize: 15 }} />}
                >
                  {confirmUploading ? "Uploading…" : "Add file"}
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
                    onChange={onConfirmFilePick}
                  />
                </Button>
              </div>

              {confirmFiles.length > 0 ? (
                <div className={classes.proofList}>
                  {confirmFiles.map((f) => (
                    <div key={f.url} className={classes.proofItem}>
                      <InsertDriveFileRoundedIcon style={{ fontSize: 16, color: "#5D6B82", flexShrink: 0 }} />
                      <a
                        className={classes.proofName}
                        href={f.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={f.name}
                      >
                        {f.name}
                      </a>
                      <IconButton
                        size="small"
                        aria-label={`Remove ${f.name}`}
                        onClick={() => removeConfirmFile(f.url)}
                        disabled={confirming}
                      >
                        <CloseRoundedIcon style={{ fontSize: 15 }} />
                      </IconButton>
                    </div>
                  ))}
                </div>
              ) : (
                <div className={classes.proofHint}>
                  A screenshot or document showing the work is done. Up to {MAX_CONFIRM_FILES}.
                </div>
              )}
            </div>
          </div>

          <div className={classes.confirmActions}>
            <Button
              className={classes.ghostBtn}
              onClick={handleDialogClose}
              disabled={confirming}
            >
              Cancel
            </Button>
            {/* One button, not three near-identical ones differing only by
                handler - and styled as the primary action, which the matching
                outlined pair never was. */}
            <Button
              className={isCloseMode ? classes.dangerBtn : classes.primaryBtn}
              onClick={isCloseMode ? handleCloseConfirm : handleResolveConfirm}
              disabled={confirming}
              startIcon={confirming
                ? <CircularProgress size={15} thickness={5} style={{ color: "#fff" }} />
                : null}
            >
              {confirming
                ? (isCloseMode ? "Closing…" : "Resolving…")
                : (isCloseMode ? "Close ticket" : "Mark resolved")}
            </Button>
          </div>
        </Dialog>
      </Fragment>

      <Fragment>
        <Dialog
          open={viewDeleteConfirmationDialog}
          keepMounted
          // onClose, not onClick. This had onClick on the Dialog itself, so a
          // click ANYWHERE inside it - including on Delete - dismissed the
          // box; the delete only still worked because the button's own
          // handler fired on the way up.
          onClose={() => { setViewDeleteConfirmationDialog(false); }}
          maxWidth="xs"
          fullWidth
          PaperProps={{ className: classes.confirmPaper }}
          aria-labelledby="delete-dialog-title"
        >
          <div className={classes.confirmHead} style={{ background: "#8C1D18" }}>
            <span className={classes.confirmHeadIcon}>
              <DeleteOutlineRoundedIcon style={{ fontSize: 20 }} />
            </span>
            <div style={{ minWidth: 0 }}>
              <div id="delete-dialog-title" className={classes.confirmTitle}>Delete this ticket?</div>
              <div className={classes.confirmSub}>This cannot be undone.</div>
            </div>
          </div>

          <div className={classes.confirmBody}>
            {/* The old box named no ticket at all - just "this Internal
                Ticket". For something irreversible, which one matters. */}
            <div className={classes.ticketCard}>
              <div className={classes.ticketRow}>
                <span className={classes.ticketLabel}>Ticket ID</span>
                <span className={classes.ticketIdText}>
                  {deleteIssueData?.uniqueTicketNo || "—"}
                </span>
              </div>
              <div className={classes.ticketRow} style={{ alignItems: "flex-start" }}>
                <span className={classes.ticketLabel}>Title</span>
                <span className={classes.ticketTitleText}>
                  {deleteIssueData?.ticketTitle || "—"}
                </span>
              </div>
            </div>
          </div>

          <div className={classes.confirmActions}>
            <Button
              className={classes.ghostBtn}
              onClick={() => { setViewDeleteConfirmationDialog(false); }}
            >
              Cancel
            </Button>
            <Button className={classes.dangerBtn} onClick={handleDeleteConfirm}>
              Delete ticket
            </Button>
          </div>
        </Dialog>

        <Dialog
          open={viewReassignIssueDialog}
          keepMounted
          onClose={reassigning ? undefined : () => { setViewReassignIssueDialog(false); resetReassignPicker(); }}
          maxWidth="sm"
          fullWidth
          PaperProps={{ className: classes.viewPaper }}
          aria-labelledby="reassign-title"
        >
          <div className={classes.confirmHead}>
            <span className={classes.confirmHeadIcon}>
              <SwapHorizRoundedIcon style={{ fontSize: 20 }} />
            </span>
            <div style={{ minWidth: 0 }}>
              <div id="reassign-title" className={classes.confirmTitle}>Reassign this ticket</div>
              <div className={classes.confirmSub}>
                {reassignIssueData?.uniqueTicketNo
                  ? `${reassignIssueData.uniqueTicketNo} — currently with ${reassignIssueData?.assignedTo?.name || "nobody"}`
                  : "Pick who it should go to."}
              </div>
            </div>
          </div>

          <div style={{ height: 3 }}>
            {(reassigning || dirLoading) && <LinearProgress className={classes.confirmBar} />}
          </div>

          <div className={classes.confirmBody}>
            {/* Four dependent steps, each appearing only once the one above it
                is answered. Showing all four at once invites filling the
                bottom one first, where every option would be wrong. */}
            <div className={classes.raStack}>
              <div className={classes.raStep}>
                <span className={classes.raBadge}>1</span>
                <div style={{ flexGrow: 1, minWidth: 0 }}>
                  <label className={classes.raLabel}>Department</label>
                  <Autocomplete
                    size="small"
                    disabled={dirLoading || reassigning}
                    options={raDepartmentOptions}
                    value={raDept}
                    onChange={(e, v) => { setRaDept(v); setRaCity(null); setRaCentre(null); pickReassignUser(null); }}
                    getOptionLabel={(o) => o?.name || ""}
                    getOptionSelected={(o, v) => o._id === v._id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={dirLoading ? "Loading…" : "Pick a department"}
                      />
                    )}
                  />
                  {!reassignIsTechTicket && (
                    <span className={classes.raHint}>
                      Tech is not listed — only an ERP Tech Support ticket can be moved to the Tech team.
                    </span>
                  )}
                </div>
              </div>

              {raDept && (
                <div className={classes.raStep}>
                  <span className={classes.raBadge}>2</span>
                  <div style={{ flexGrow: 1, minWidth: 0 }}>
                    <label className={classes.raLabel}>City</label>
                    <Autocomplete
                      size="small"
                      disabled={reassigning}
                      options={raCityOptions}
                      value={raCity}
                      onChange={(e, v) => { setRaCity(v); setRaCentre(null); pickReassignUser(null); }}
                      getOptionLabel={(o) => o?.name || ""}
                      getOptionSelected={(o, v) => o._id === v._id}
                      noOptionsText={`Nobody in ${raDept?.name || "this department"} has a centre set`}
                      renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Pick a city" />}
                    />
                    <span className={classes.raHint}>
                      {`${raCityOptions.length} ${raCityOptions.length === 1 ? "city" : "cities"} with people in ${raDept?.name || "this department"}`}
                    </span>
                  </div>
                </div>
              )}

              {raDept && raCity && (
                <div className={classes.raStep}>
                  <span className={classes.raBadge}>3</span>
                  <div style={{ flexGrow: 1, minWidth: 0 }}>
                    <label className={classes.raLabel}>Experience Center</label>
                    <Autocomplete
                      size="small"
                      disabled={reassigning}
                      options={raCentreOptions}
                      value={raCentre}
                      onChange={(e, v) => { setRaCentre(v); pickReassignUser(null); }}
                      getOptionLabel={(o) => o?.name || ""}
                      getOptionSelected={(o, v) => o._id === v._id}
                      noOptionsText={`No centre in ${raCity?.name || "this city"} has anyone from ${raDept?.name || "this department"}`}
                      renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Pick an experience center" />}
                    />
                  </div>
                </div>
              )}

              {raCity && raCentre && (
                <div className={classes.raStep}>
                  <span className={classes.raBadge}>4</span>
                  <div style={{ flexGrow: 1, minWidth: 0 }}>
                    <label className={classes.raLabel}>Reassign to</label>
                    <Autocomplete
                      size="small"
                      disabled={reassigning}
                      options={raUserOptions}
                      value={raUser}
                      onChange={(e, v) => pickReassignUser(v)}
                      getOptionLabel={(o) => o?.name || o?.email || ""}
                      getOptionSelected={(o, v) => o._id === v._id}
                      noOptionsText="Nobody else here to move it to"
                      // Name, email and role on every row - picking by email
                      // alone means guessing which M Kumar you mean.
                      renderOption={(o) => (
                        <div className={classes.raUserRow}>
                          <span className={classes.raAvatar}>{raInitials(o.name)}</span>
                          <div style={{ minWidth: 0 }}>
                            <div className={classes.raUserName}>{o.name || "—"}</div>
                            <div className={classes.raUserMeta}>{o.email}</div>
                            {raRoles(o) && <div className={classes.raUserRole}>{raRoles(o)}</div>}
                          </div>
                        </div>
                      )}
                      renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Pick who it goes to" />}
                    />
                    <span className={classes.raHint}>
                      {raUser
                        ? `${raUser.name} · ${raUser.email}`
                        : `${raUserOptions.length} ${raUserOptions.length === 1 ? "person" : "people"} in ${raCentre?.name || "this centre"}`}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={classes.confirmActions}>
            {/* Says WHY the button is greyed out - a disabled button with no
                reason beside it is what gets reported as broken. */}
            {!emailTag && !reassigning && (
              <span className={classes.raBlocker}>
                {!raDept ? "Pick a department to start"
                  : !raCity ? "Pick a city"
                    : !raCentre ? "Pick an experience center"
                      : "Pick who it goes to"}
              </span>
            )}
            <Button
              className={classes.ghostBtn}
              onClick={() => { setViewReassignIssueDialog(false); resetReassignPicker(); }}
              disabled={reassigning}
            >
              Cancel
            </Button>
            <Button
              className={classes.primaryBtn}
              onClick={handleReassignIssueConfirm}
              disabled={!emailTag || reassigning}
              startIcon={reassigning
                ? <CircularProgress size={15} thickness={5} style={{ color: "#fff" }} />
                : null}
            >
              {reassigning ? "Reassigning…" : "Reassign"}
            </Button>
          </div>
        </Dialog>
      </Fragment>

      <Fragment>
        <Dialog
          open={viewEditIssueDialog}
          keepMounted
          onClose={handleEditDialogClose}
          maxWidth="md"
          fullWidth
          PaperProps={{ className: classes.viewPaper }}
          aria-labelledby="edit-dialog-title"
        >
          <div className={classes.confirmHead}>
            <span className={classes.confirmHeadIcon}>
              <EditRoundedIcon style={{ fontSize: 20 }} />
            </span>
            <div style={{ minWidth: 0, flexGrow: 1 }}>
              <div id="edit-dialog-title" className={classes.confirmTitle}>Edit ticket</div>
              <div className={classes.confirmSub}>
                {editIssueData?.uniqueTicketNo || "Change the title, description or due date."}
              </div>
            </div>
            <IconButton size="small" onClick={handleEditDialogClose} className={classes.viewClose}>
              <CloseRoundedIcon style={{ fontSize: 19 }} />
            </IconButton>
          </div>

          <div className={classes.editBody}>
            <div>
              {/* Labelled "New Title" / "New Description" as h5 headings
                  before - as big as the dialog's own title, and "New" reads
                  like it creates something. */}
              <label htmlFor="editTicketTitle" className={classes.editLabel}>Title</label>
              <TextField
                id="editTicketTitle"
                inputRef={titleRef}
                value={editTicketTitle}
                variant="outlined"
                size="small"
                fullWidth
                placeholder="Short summary of the issue"
                onChange={(e) => setEditTicketTitle(e.target.value)}
              />
            </div>

            <div>
              <label className={classes.editLabel}>Description</label>
              <div className={classes.quillEditor}>
                <ReactQuill
                  theme="snow"
                  value={editTicketDes}
                  onChange={(value) => setEditTicketDes(value)}
                  modules={quillModules}
                  formats={quillFormats}
                  placeholder="Enter ticket description..."
                />
              </div>
            </div>

            <div style={{ maxWidth: 240 }}>
              <label htmlFor="editDueDate" className={classes.editLabel}>Due date</label>
              <TextField
                id="editDueDate"
                name="dueDate"
                type="date"
                value={editDueDate}
                onChange={handleEditDueDateChange}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                size="small"
                fullWidth
              />
            </div>
          </div>

          {/* Out of the scrolling body and into their own row, so they do not
              scroll away under a long description. */}
          <div className={classes.confirmActions}>
            <Button className={classes.ghostBtn} onClick={() => setViewEditIssueDialog(false)}>
              Cancel
            </Button>
            <Button className={classes.primaryBtn} onClick={handleEditConfirm}>
              Save changes
            </Button>
          </div>
        </Dialog>
      </Fragment>

      <Fragment>
        <Dialog
          open={viewReopenDialog}
          keepMounted
          onClose={actionBusy ? undefined : () => { setViewReopenDialog(false); setReopenRemarks(""); }}
          maxWidth="xs"
          fullWidth
          PaperProps={{ className: classes.confirmPaper }}
          aria-labelledby="reopen-dialog-title"
        >
          <div className={classes.confirmHead} style={{ background: "#7A5500" }}>
            <span className={classes.confirmHeadIcon}>
              <ReplayIcon style={{ fontSize: 20 }} />
            </span>
            <div style={{ minWidth: 0 }}>
              <div id="reopen-dialog-title" className={classes.confirmTitle}>Reopen this ticket?</div>
              <div className={classes.confirmSub}>
                It goes back to its owner and starts counting again.
              </div>
            </div>
          </div>

          <div style={{ height: 3 }}>
            {actionBusy && <LinearProgress className={classes.confirmBar} />}
          </div>

          <div className={classes.confirmBody}>
            {/* reopenIssueData, not viewIssueData. The body read the latter -
                which only the View dialog ever sets - so reopening straight
                from the row menu showed a blank ticket, or the last one you
                had VIEWED, while Confirm acted on the right one. */}
            <div className={classes.ticketCard}>
              <div className={classes.ticketRow}>
                <span className={classes.ticketLabel}>Ticket ID</span>
                <span className={classes.ticketIdText}>
                  {reopenIssueData?.uniqueTicketNo || "—"}
                </span>
              </div>
              <div className={classes.ticketRow} style={{ alignItems: "flex-start" }}>
                <span className={classes.ticketLabel}>Title</span>
                <span className={classes.ticketTitleText}>
                  {reopenIssueData?.ticketTitle || "—"}
                </span>
              </div>
            </div>

            <TextField
              id="reopenRemarks"
              name="remarks"
              label="Why is it being reopened?"
              value={reopenRemarks}
              onChange={(e) => setReopenRemarks(e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={3}
              required
              disabled={actionBusy}
              placeholder="What is still outstanding?"
              InputLabelProps={{ shrink: true }}
              // Required, unlike the remark on Close and Resolve -
              // handleReopenConfirm refuses without it. Marked as such rather
              // than left to a toast after the click.
              helperText="Required — the owner sees this first."
            />
          </div>

          <div className={classes.confirmActions}>
            {/* Says WHY the button is greyed out. */}
            {!reopenRemarks.trim() && !actionBusy && (
              <span className={classes.raBlocker}>Add a remark to reopen</span>
            )}
            <Button
              className={classes.ghostBtn}
              onClick={() => { setViewReopenDialog(false); setReopenRemarks(""); }}
              disabled={actionBusy}
            >
              Cancel
            </Button>
            {ribbonTagValue === "Tickets Assigned By Me" && (
              <Button
                className={classes.reopenBtn}
                onClick={handleReopenConfirm}
                disabled={!reopenRemarks.trim() || actionBusy}
                startIcon={actionBusy
                  ? <CircularProgress size={15} thickness={5} style={{ color: "#fff" }} />
                  : null}
              >
                {actionBusy ? "Reopening…" : "Reopen ticket"}
              </Button>
            )}
          </div>
        </Dialog>
      </Fragment>

      <Fragment>
        <Dialog
          open={openCreateTicketDialog}
          onClose={() => closeCreateTicketDialog()}
          maxWidth={"xl"}
        >
          <CreateTaskTicket
            visibilityFunction={setOpenCreateTicketDialog}
            refreshParentDataNo={getDataOnPageLoading}
            refreshParentData={getFilteredTickets}
          ></CreateTaskTicket>
        </Dialog>
      </Fragment>
    </Fragment>
  );
};

export default connect(null, { setSnackInfo })(TaskManagementDashBoard);
